<template>
	<b-modal :no-close-on-backdrop="true" :hide-header-close="isLoading" ref="modal" :title="title" size="1600" class="modal-primary" @hidden="clearModalData">
		<CRow>
			<CCol>
				<b-card>
					<div slot="header">
						<CRow>
							<CCol>
								<CRow>
									<CCol class="col-auto pt-2">
										<b>Št. delovnega naloga</b>
									</CCol>
									<CCol>
										<v-select
											v-if="motiondataConfig().orderNumberSearch.enabled == 'true'"
											:disabled="mode != mode_CREATE1"
											v-model="spOrder.spOrderNumber"
											label="orderNumber"
											:options="orderNumber_options"
											@input="orderNumberSelect_change($event)"
											@search="orderNumberSelect_search"
											placeholder="Izberi št. DN">
											<template slot="no-options">Vnesite št. DN</template>
											<template slot="option" slot-scope="option">
												<div v-if="option.internalId">{{ option.orderNumber }}</div>
												<div v-else><b>Dodaj {{ option.orderNumber }}</b></div>
											</template>
										</v-select>
										<CInput v-else
											@input="setSpOrderEditing"
											:disabled = editingDisabled
											v-model="spOrder.spOrderNumber"/>
									</CCol>
									<CCol class="col-auto pt-1">
										<b-badge v-if="spOrderNumberCopied" variant="primary">Copied!</b-badge>
									
										<CLink class="ml-2 pt-0" color="primary" title="Kopiraj št. DN" @click.stop="copyToCliboard(spOrder.spOrderNumber, 'spOrderNumber')">
											<CIcon name="cil-copy"  size="lg"/>
										</CLink>
									</CCol>
									<CCol class="col-auto pt-1">
										<CLink class="ml-2 pt-0" color="primary" title="Osveži podatke" @click.stop="getSpOrderExternalData(spOrder.spOrderNumber)">
											<CIcon name="cil-loop-circular"  size="lg"/>
										</CLink>
									</CCol>
								</CRow>
							</CCol>
							<CCol sm=6></CCol>
						</CRow>
					</div>
					<CRow>
						<CCol sm=3>
							<CRow>
								<CCol>
									<label>VIN</label>
									<v-select
										:disabled="editingDisabled"
										v-model="spOrder.vin"
										label="ogrodje"
										:options="vehicle_options"
										:taggable="true"
										@input="vehicleSelect_change($event)"
										@search="vehicleSelect_search"
										placeholder="Izberi vozilo ...">
										<template slot="no-options">Vnesite VIN številko vozila</template>
										<template slot="option" slot-scope="option">
											<div v-if="option.id">{{ option.ogrodje }}</div>
											<div v-else><b>Dodaj vozilo {{option.ogrodje}}</b></div>
										</template>
									</v-select>
								</CCol>
								<CCol sm="2" class="p-sm-0">
									<div>
										<b-badge v-if="vinCopied" variant="primary">Copied!</b-badge>
									</div>
									<div :class="vinCopied ? 'copyButtonClicked' : 'copyButton'" >
										<CLink color="primary"  title="Kopiraj VIN" @click.stop="copyToCliboard(spOrder.vin, 'vin')">
											<CIcon name="cil-copy" size="lg"/>
										</CLink>
									</div>
								</CCol>
							</CRow>
						</CCol>
						<CCol sm=2>
							<label>Znamka</label>
							<v-select
								:disabled="editingDisabled"
								v-model="selectedBrand"
								:options="allVehicleBrands"
								:filter-by="filter_brandsSelect"
								label="title"
								@input="change_brandsSelect"
								placeholder="Izberi znamko ...">
								<template slot="no-options">Znamka ne obstaja</template>
								<template slot="option" slot-scope="option">
									<b-row>
										<b-col cols=2 class="p-0 m-0">
											<div v-if="option.logo" :style="imagesTool.vehicleBrandImage(option.logo, 2)"></div>
											<CIcon v-else :style="imagesTool.vehicleBrandIcon(2)" name="cil-car-alt"/>
										</b-col>
										<b-col class="pl-0 pt-2">
											{{ option.title }}
										</b-col>
									</b-row>
								</template> 
								<template slot="selected-option" slot-scope="option">
									<div v-if="option.logo" :style="imagesTool.vehicleBrandImage(option.logo, 1.3)"></div>
									<CIcon v-else :style="imagesTool.vehicleBrandIcon(1.3)" name="cil-car-alt"/>
									<div class="ml-2">{{ option.title }}</div>
								</template>
							</v-select>
						</CCol>
						<CCol sm=2>
							<CInput
								@input="setSpOrderEditing"
								:disabled = editingDisabled
								label="Model"
								v-model="spOrder.model"/>
						</CCol>
						<CCol sm=2>
							<CRow>
								<CCol sm="10">
									<CInput
										@input="setSpOrderEditing"
										:disabled = editingDisabled
										label="Registrska"
										v-model="spOrder.registrationNumber"/>
								</CCol>
								<CCol sm="2" class="p-sm-0">
									<div >
										<b-badge v-if="registrationNumberCopied" variant="primary">Copied!</b-badge>
									</div>
									<div :class="registrationNumberCopied ? 'copyButtonClicked' : 'copyButton'" >
										<CLink color="primary" title="Kopiraj registrsko št." @click.stop="copyToCliboard(spOrder.registrationNumber, 'registrationNumber')">
											<CIcon name="cil-copy" size="lg"/>
										</CLink>
									</div>
								</CCol>
							</CRow>
						</CCol>
						<CCol>
						<CRow>
							<CCol sm=5>
								<label>Garancija</label>
								<v-select
									@input="setSpOrderEditing"
									:disabled="editingDisabled"
									v-model="spOrder.warranty"
									:options="settings.spOrderWarrantyOptions"
									placeholder="Izberi">
								</v-select>
							</CCol>
							<CCol>
								<label>Nadomestno vozilo</label>
								<v-select
									:disabled="editingDisabled"
									v-model="selectedReplacementVehicle"
									label="registration_number"
									:options="replacementVehicles"
									@input="change_replacementVehicleSelect"
									placeholder="Izberi vozilo ...">
									<template slot="no-options">Vnesite vin vozila</template>
									<template slot="option" slot-scope="option">
										<div v-if="option.id">{{ option.registration_number }}</div>
										<div v-if="option.latest_reservation">
											<b-badge :variant="getReplacementVehicleStatus(option).variant">{{ option.latest_reservation.starts_on | viewDate }} - {{ option.latest_reservation.ends_on | viewDate }}</b-badge>
										</div>
										<div v-else>
											<b-badge variant="success">Prosto</b-badge>
										</div>
									</template>
									<template slot="selected-option" slot-scope="option">
										<div v-if="option.id">{{ option.registration_number }}</div>
									</template>
								</v-select>
								<b-badge v-if="currentReplacementVehicleReservation.id">{{ currentReplacementVehicleReservation.startsOn | viewDate }} - {{ currentReplacementVehicleReservation.endsOn | viewDate }}</b-badge>
							</CCol>
						</CRow>
						</CCol>
					</CRow>
					<CRow>
						<CCol sm=3>
							<CRow>
								<CCol>
									<label>Stranka</label>
									<v-select
										:disabled="editingDisabled"
										ref="vSelectClient"
										v-model="selectedSpOrderClient"
										:options="allSpOrderClients"
										:filter-by="filter_clientsSelect"
										:taggable="true"
										label="first_name"
										@input="change_spOrderClientsSelect"
										placeholder="Izberi stranko ...">
										<template slot="no-options">Stranka ne obstaja</template>
										<template slot="option" slot-scope="option">
											<div v-if="option.id">{{ getClientSelectLabel(option )}}</div>
											<div v-else><b>Dodaj stranko {{option.first_name}}</b></div>
										</template>
										<template slot="selected-option" slot-scope="option">
											{{ getClientSelectLabel(option, 'selected-option')}}
										</template>
									</v-select>
								</CCol>
								<CCol sm="2" class="p-sm-0">
									<div class="clientEditButton" >
										<CLink :disabled="!selectedSpOrderClient" title="Uredi stranko" href="#" @click.stop="click_editClient">
											<CIcon name="cil-pencil"/>
										</CLink>
									</div>
								</CCol>
							</CRow>
						</CCol>
						<CCol sm=2 v-if="editingDisabled">
							<CInput
								:disabled = editingDisabled
								label="Datum naročila"
								:value="spOrder.date | viewDate"/>
						</CCol>
						<CCol sm=2 v-else>
							<v-date-picker
								locale="sl-SI"
								@input="setSpOrderEditing"
								v-model="spOrder.date"
								:model-config=" {
									type: 'string',
								}"
								timezone='utc'>
								<template v-slot="{ inputValue, inputEvents }">
									<CInput
										label="Datum naročila"
										:value="inputValue"
										v-on="inputEvents"/>
								</template>
							</v-date-picker>
						</CCol>
						<CCol sm=2>
							<label>Lokacija</label>
							<v-select
								@input="setSpOrderEditing"
								:disabled="editingDisabled"
								v-model="spOrder.location"
								:options="settings.spOrderLocationOptions"
								:taggable="true"
								placeholder="Izberi lokacijo ...">
								<template slot="option" slot-scope="option">
									{{ getLocationLabel(option) }}
								</template>
								<template slot="selected-option" slot-scope="option">
									{{ getLocationLabel(option, 'selected-option')}}
								</template>
							</v-select>
						</CCol>
						<CCol sm=2>
							<CInput
								v-if="false"
								@input="setSpOrderEditing"
								:disabled="editingDisabled"
								label="Sprejemnik"
								v-model="spOrder.serviceAdvisor"/>
							<label>Sprejemnik</label>
							<v-select
								:disabled="editingDisabled"
								v-model="selectedServiceAdvisor"
								label="name"
								:options="allServiceAdvisors"
								:filter-by="filter_orderersSelect"
								@input="change_serviceAdvisorSelect"
								placeholder="Izberi sprejemnika ...">
								<template slot="no-options">Vnesite ime sprejemnika</template>
								<template slot="option" slot-scope="option">
									<div v-if="option.id">{{ option.initials }} - {{ option.name }}</div>
								</template>
							</v-select>
						</CCol>
						<CCol>
							<label>Naročnik</label>
							<v-select
								:disabled="editingDisabled"
								v-model="selectedOrderer"
								label="name"
								:options="allSpOrderers"
								:filter-by="filter_orderersSelect"
								@input="change_ordererSelect"
								placeholder="Izberi naročnika ...">
								<template slot="no-options">Vnesite ime naročnika</template>
								<template slot="option" slot-scope="option">
									<div v-if="option.id">{{ option.initials }} - {{ option.name }}</div>
								</template>
							</v-select>
						</CCol>
					</CRow>
					<div v-if="false" slot="footer">
						<b-row>
							<b-col class="ma_pos">
								<b-button v-if="mode !== mode_CREATE1" :disabled="!isSpOrderEditing" title="Razveljavi spremembe" variant="danger" @click.stop="click_spOrderEditCancel()" size="sm" class="mr-2">
									<CIcon name="cil-x"/>
								</b-button>
								<b-button :disabled="!isSpOrderEditing" :title="spOrderOkButton.title" variant="success" @click.stop="click_spOrderCreate()" size="sm" class="mr-2">
									<CIcon name="cil-check-alt"/>
								</b-button>
							</b-col>
						</b-row>
					</div>
				</b-card>
			</CCol>
		</CRow>
		<CRow v-if="mode == mode_EDIT2 || mode == mode_DETAILS3">
			<CCol>
				<b-card>
					<div id="spOrderCustomActions">
						<div v-if="movingSpOrderItemsInProgress">
							<td>
								<v-select
									class="spOrderSelectMoving"
									label="sp_order_number"
									:options="spOrders_options"
									@input="spOrderSelect_change($event)"
									@search="spOrderSelect_search"
									placeholder="Izberi št. DN...">
									<template slot="no-options">Vnesite št. DN</template>
									<template slot="option" slot-scope="option">
										{{ option.sp_order_number }}
									</template>
								</v-select>
							</td>
							<td>
								<b-button title="Prenesi izbrane postavke" :disabled="editingDisabled" variant="primary" @click.stop="click_changeSpOrder()" size="sm" class="ml-2">
									<CIcon name="cil-check-alt"/>
								</b-button>
								<b-button title="Prekliči premik postavk" :disabled="editingDisabled" variant="danger" @click.stop="click_cancelChangeSpOrder()" size="sm" class="ml-2">
									<CIcon name="cil-x"/>
								</b-button>
							</td>
						</div>
						<span v-else>
							<b-button title="Prenos postavk" :disabled="editingDisabled" variant="primary" @click.stop="click_changeSpOrder()" size="sm">
								<CIcon name="cil-notes"/>
								<CIcon name="cil-arrow-right"/>
								<CIcon name="cil-notes"/>
							</b-button>
							<b-button title="Dodaj novo prilogo" :disabled="editingDisabled" variant="primary" @click.stop="click_addSpOrderAttachment()" size="sm" class="ml-2">
								<CIcon name="cil-plus"/><CIcon name="cil-file"/>
							</b-button>
							<b-button title="Dodaj nov komentar" :disabled="editingDisabled" variant="primary" @click.stop="click_openSpOrderCommentCreateModal()" size="sm" class="ml-2">
								<CIcon name="cil-plus"/><CIcon name="cil-comment-square"/>
							</b-button>
						</span>
					</div>
					<b-tabs v-model="selectedTabIndex">
						<b-tab title="Postavke" class="pt-2" >
							<b-table
								:class="spOrderItemsTableClass"
								ref="spOrderItemsTable"
								striped
								responsive
								hover
								show-empty
								empty-text="Ni postavk"
								:fields="spOrderItemsTableFields"
								:items="spOrderItemsTable_items"
								:current-page="spOrderItemsTableProps.currentPage"
								:per-page="spOrderItemsTableProps.itemsPerPage">
								<template v-if="!spOrderItemsEditingDisabled && !movingSpOrderItemsInProgress" slot="top-row">
									<td class="addingSpOrderItemsRow">
										<v-select
											v-if="motiondataConfig().catalogNumberSearch.enabled == 'true'"
											:disabled="spOrderItemsEditingDisabled"
											v-model="newSpOrderItem.catalog_number"
											label="partNumber"
											:options="catalogNumber_options"
											:taggable="catalogNumber_options.length < 1 ? true : false"
											@input="catalogNumberSelect_change($event)"
											@search="catalogNumberSelect_search"
											placeholder="Izberi kataloško št."
											>
											<template slot="no-options">Vnesite kataloško št.</template>
											<template slot="option" slot-scope="option">
												<div v-if="option.description">{{ option.partNumber }} - {{ option.description }}</div>
												<div v-else><b>Izberi {{ option.partNumber }}</b></div>
											</template>
										</v-select>
										<CInput v-else class="inTableInput" :disabled="isSpOrderItemEditing" type="text" v-model="newSpOrderItem.catalog_number"/>
									</td>
									<td class="addingSpOrderItemsRow"><CInput class="inTableInput" :disabled="isSpOrderItemEditing" type="text" v-model="newSpOrderItem.title"/></td>
									<td class="addingSpOrderItemsRow"><CInput class="inTableInput" :disabled="isSpOrderItemEditing" type="text" v-model="newSpOrderItem.note"/></td>
									<td class="addingSpOrderItemsRow"><CInput class="inTableInput" :disabled="isSpOrderItemEditing" type="text" v-model="newSpOrderItem.stock"/></td>
									<td class="addingSpOrderItemsRow">
										<v-select
											:disabled="isSpOrderItemEditing"
											v-model="newSpOrderItem.status"
											:options="spOrderItemsStatusOptions"
											@input="newSpOrderItemStatusChange(newSpOrderItem.item)"
											placeholder="Izberi status ..."
											:searchable="false">
											<template slot="no-options">Ni statusov</template>
											<template slot="option" slot-scope="option">
												<b-badge class="text-wrap" :variant="option.variant">{{ option.label }}</b-badge>
											</template>
											<template slot="selected-option" slot-scope="option">
												<b-badge class="text-wrap" :variant="option.variant">{{ option.label }}</b-badge>
											</template>
										</v-select>
									</td>
									<td class="addingSpOrderItemsRow">
										<sp-order-item-estimated-date-dropdown :disabled="isSpOrderItemEditing"  v-model="newSpOrderItem.estimated_delivery_date" @input="newSpOrderItemEstimatedDateInput"/>
										</td>
									<td class="addingSpOrderItemsRow">
										<CInput disabled :value="new Date() | viewDate"/>
										</td>
									<td class="addingSpOrderItemsRow"><CInputCheckbox class="inTableInput" :disabled="isSpOrderItemEditing" :custom="true" :checked.sync="newSpOrderItem.in_house" label="" inline @input="newSpOrderItemInHouseChange"/></td>
									<td class="addingSpOrderItemsRow"><CInput class="inTableInput" :disabled="isSpOrderItemEditing" type="text" v-model="newSpOrderItem.info"/></td>
									<td class="ma_pos addingSpOrderItemsRow">
										<b-button title="Prekliči" :disabled="isSpOrderItemEditing" variant="danger" @click.stop="click_spOrderItemClear()" size="sm" class="mr-2">
											<CIcon name="cil-x"/>
										</b-button>
										<b-button :disabled="isSpOrderItemEditing" title="Dodaj postavko" variant="primary" @click.stop="click_spOrderItemCreate()" size="sm" class="mr-2">
											<CIcon name="cil-plus"/>
										</b-button>
									</td>
								</template>
								<template v-slot:cell(catalog_number)="data">
									<CRow>
										<CCol>
											<div v-if="!spOrderItemsEditingDisabled">
												<CInput
													class="inTableInput"
													@input="setSpOrderItemEditing(data.item)"
													:disabled="isEditingSpOrderItemDisabled(data.item)"
													type="text"
													v-model="data.item.catalog_number"/>
											</div>
											<div v-else>
												{{ data.item.catalog_number }}
											</div>
										</CCol>
										<CCol col=2>
											<CIcon class="mb-1" name="cil-calendar" :title="data.item.created_at | viewDateTime"/>
										</CCol>
									</CRow>
								</template>
								<template v-slot:cell(title)="data">
									<div v-if="!spOrderItemsEditingDisabled">
										<CInput
											class="inTableInput"
											@input="setSpOrderItemEditing(data.item)"
											:disabled="isEditingSpOrderItemDisabled(data.item)"
											type="text"
											v-model="data.item.title"/>
									</div>
									<div v-else>
										{{ data.item.title }}
									</div>
								</template>
								<template v-slot:cell(status)="data">
									<div v-if="!spOrderItemsEditingDisabled">
										<v-select
											:disabled="isEditingSpOrderItemDisabled(data.item)"
											v-model="data.item.status"
											@input="spOrderItemStatusChange(data.item)"
											:options="spOrderItemsStatusOptions"
											placeholder="Izberi status ..."
											:searchable="false">
											<template slot="no-options">Ni statusov</template>
											<template slot="option" slot-scope="option">
												<b-badge class="text-wrap" :variant="option.variant">{{ option.label }}</b-badge>
											</template>
											<template slot="selected-option" slot-scope="option">
												<b-badge class="text-wrap" :variant="option.variant" :title="getStatusTitle(data.item)">{{ option.label }}</b-badge>
											</template>
										</v-select>
									</div>
									<div v-else>
										<b-badge class="text-wrap" v-if="data.item.status" :variant="data.item.status.variant"  :title="getStatusTitle(data.item)">{{ data.item.status.label }}</b-badge>
									</div>
								</template>
								<template v-slot:cell(estimated_delivery_date)="data">
									<CRow>
										<CCol>
										<div v-if="!spOrderItemsEditingDisabled">
										<sp-order-item-estimated-date-dropdown :disabled="isEditingSpOrderItemDisabled(data.item)" v-model="data.item.estimated_delivery_date" :default_label="getEstimatedDeliveryDateLabel(data.item)" @input="setSpOrderItemEditing(data.item)"/>
									</div>
									<div v-else>
										{{ getEstimatedDeliveryDateLabel(data.item) }}
									</div>
										</CCol>
										<CCol col=2>
											<CIcon v-if="data.item.in_house_set_by_user" class="mb-1" name="cil-user" :title="data.item.in_house_set_by_user.name"/>
										</CCol>
									</CRow>
								</template>
								<template v-slot:cell(created_at)="data">
									{{  data.item.created_at | viewDate }}
								</template>
								<template v-slot:cell(note)="data">
									<div v-if="!spOrderItemsEditingDisabled">
										<CInput
											class="inTableInput"
											@input="setSpOrderItemEditing(data.item)"
											:disabled="isEditingSpOrderItemDisabled(data.item)"
											type="text"
											v-model="data.item.note"/>
									</div>
									<div v-else>
										{{ data.item.note }}
									</div>
								</template>
								<template v-slot:cell(info)="data">
									<div v-if="!spOrderItemsEditingDisabled">
										<CInput
											class="inTableInput"
											@input="setSpOrderItemEditing(data.item)"
											:disabled="isEditingSpOrderItemDisabled(data.item)"
											type="text"
											v-model="data.item.info"/>
									</div>
									<div v-else>
										{{ data.item.info }}
									</div>
								</template>
								<template v-slot:cell(stock)="data">
									<div v-if="!spOrderItemsEditingDisabled">
										<CInput
											class="inTableInput"
											@input="setSpOrderItemEditing(data.item)"
											:disabled="isEditingSpOrderItemDisabled(data.item)"
											type="text"
											v-model="data.item.stock"/>
									</div>
									<div v-else>
										{{ data.item.stock }}
									</div>
								</template>
								<template v-slot:cell(in_house)="data">
									<CInputCheckbox 
										class="inTableInput"
										@input="spOrderItemInHouseChange(data.item)"
										:disabled="spOrderItemsEditingDisabled || isEditingSpOrderItemDisabled(data.item)" 
										:custom="true" 
										:checked="!!data.item.in_house" 
										:label="data.item.in_house_setted_at ? $options.filters.viewDate(data.item.in_house_setted_at) : ''" 
										inline/>
								</template>
								<template v-if="!spOrderItemsEditingDisabled" v-slot:cell(actions)="data">
									<div class="ma_pos">
										<b-button v-if="!data.item.edited" :disabled="isEditingSpOrderItemDisabled(data.item)" title="Odstrani" variant="danger" @click.stop="click_spOrderItemRemove(data.item)" size="sm" class="mr-2">
											<CIcon name="cil-trash"/>
										</b-button>
										<b-button v-else title="Prekliči" variant="danger" @click.stop="click_spOrderItemCancel(data.item)" size="sm" class="mr-2">
											<CIcon name="cil-x"/>
										</b-button>
										<b-button :disabled="!data.item.edited" title="Shrani" variant="primary" @click.stop="click_spOrderItemEdit(data.item)" size="sm" class="mr-2">
											<CIcon name="cil-check-alt"/>
										</b-button>
									</div>
								</template>
								<template v-slot:cell(selection)="data">
									<CInputCheckbox 
										class="inTableInput"
										@click="data.item.selected = !data.item.selected"
										:checked="!!data.item.selected"
										:custom="true"
										inline/>
								</template>
							</b-table>
							<nav v-if="showSpOrderItemsTableNav">
								<b-row>
									<b-col>
										<b-pagination :total-rows="spOrderItemsTableProps.totalItems" :per-page="spOrderItemsTableProps.itemsPerPage" v-model="spOrderItemsTableProps.currentPage" prev-text="Prejšnja" next-text="Naslednja" hide-goto-end-buttons />
									</b-col>
									<b-col cols=2>
										<a class="page-link rows_total float-right">Št. vrstic: {{ spOrderItemsTableProps.totalItems }}</a>
									</b-col>
									<b-col cols=1>
										<b-form-select v-model="spOrderItemsTableProps.itemsPerPage" :options="spOrderItemsTableProps.options_numRowsOnPage"></b-form-select>
									</b-col>
								</b-row>
							</nav>
							<vue-loading :active.sync="spOrderItemsTableProps.isLoading" :is-full-page="false"/>
						</b-tab>
						<b-tab title="Komentarji" class="pt-2" >
							<b-table
								ref="spOrderCommentsTable"
								striped
								responsive
								hover
								show-empty
								empty-text="Ni komentarjev"
								:fields="spOrderCommentsTableProps.fields"
								:items="spOrderCommentsTableProps_items"
								:current-page="spOrderCommentsTableProps.currentPage"
								:per-page="spOrderCommentsTableProps.itemsPerPage"
								:sort-desc="true">
								<template v-slot:cell(created_by)="data">
									<CRow>
										<CCol><user-avatar :small="true" :propSrc="data.item.user_created.avatar" :propUser="data.item.user_created"/></CCol>
										<CCol>{{  data.item.user_created.name }}</CCol>
									</CRow>
								</template>
								<template v-slot:cell(created_at)="data">
									{{  data.item.created_at | viewDateTime }}
								</template>
								<template v-slot:cell(content)="data">
									<div class="show-new-lines">{{  data.item.content }}</div>
								</template>
							</b-table>
							<nav v-if="showSpOrderCommentsTableNav">
								<b-row>
									<b-col>
										<b-pagination :total-rows="spOrderCommentsTableProps.totalItems" :per-page="spOrderCommentsTableProps.itemsPerPage" v-model="spOrderCommentsTableProps.currentPage" prev-text="Prejšnja" next-text="Naslednja" hide-goto-end-buttons />
									</b-col>
									<b-col cols=2>
										<a class="page-link rows_total float-right">Št. vrstic: {{ spOrderCommentsTableProps.totalItems }}</a>
									</b-col>
									<b-col cols=1>
										<b-form-select v-model="spOrderCommentsTableProps.itemsPerPage" :options="spOrderCommentsTableProps.options_numRowsOnPage"></b-form-select>
									</b-col>
								</b-row>
							</nav>
							<vue-loading :active.sync="spOrderCommentsTableProps.isLoading" :is-full-page="false"/>
						</b-tab>
						<b-tab title="Priloge" class="pt-2">
							<CRow>
								<b-table
									v-if="spOrderAttachmentsToUpload.length > 0"
									class="mb-1"
									ref="uploadSpOrderAttachmentsTable"
									thead-class="hidden_header"
									striped
									hover
									:fields="spOrderAttachmentsToUploadTable_props.fields"
									:items="spOrderAttachmentsToUpload">
										<template v-slot:cell(progress)="data">
											<b-progress class="mt-1" :value="data.item.progress" :max="100" show-progress></b-progress>
										</template>
										<template v-slot:cell(file)="data">
											{{ data.item.name }}
										</template>
								</b-table>
							</CRow>
							<CRow>
								<b-table
									ref="spOrderAttachmentsTable"
									thead-class="hidden_header"
									striped
									responsive
									hover
									show-empty
									empty-text="Ni prilog"
									:fields="spOrderAttachmentsTableProps.fields"
									:items="spOrderAttachmentsTableProps_items"
									:current-page="spOrderAttachmentsTableProps.currentPage"
									:per-page="spOrderAttachmentsTableProps.itemsPerPage">
									<template v-slot:cell(preview)="data">
										<div v-if="data.item.src" :style="imagesTool.image('data:image/jpeg;base64,'+data.item.src, 3)" @click.stop="showImage_click(data.item)" class="clickable"></div>
										<CIcon v-else name="cil-file" width="100" height="100"/>
									</template>
									<template v-slot:cell(actions)="data">
										<b-button title="Prenesi prilogo" variant="primary" class="mr-2" @click.stop="downloadSpOrderAttachment_click(data.item)" size="sm">
											<CIcon name="cil-vertical-align-bottom"/>
										</b-button>
										<b-button :disabled="editingDisabled" title="Odstrani" variant="danger" @click.stop="removeSpOrderAttachmentRetrieved_click(data.item)" size="sm">
											<CIcon name="cil-trash"/>
										</b-button>
									</template>
								</b-table>
								<nav v-if="showSpOrderAttachmentsTableNav">
									<b-row>
										<b-col>
											<b-pagination :total-rows="spOrderAttachmentsTableProps.totalItems" :per-page="spOrderAttachmentsTableProps.itemsPerPage" v-model="spOrderAttachmentsTableProps.currentPage" prev-text="Prejšnja" next-text="Naslednja" hide-goto-end-buttons />
										</b-col>
										<b-col cols=2>
											<a class="page-link rows_total float-right">Št. vrstic: {{ spOrderAttachmentsTableProps.totalItems }}</a>
										</b-col>
										<b-col cols=1>
											<b-form-select v-model="spOrderAttachmentsTableProps.itemsPerPage" :options="spOrderAttachmentsTableProps.options_numRowsOnPage"></b-form-select>
										</b-col>
									</b-row>
								</nav>
								<vue-loading :active.sync="spOrderAttachmentsTableProps.isLoading" :is-full-page="false"/>
							</CRow>
						</b-tab>
						<b-tab title="Posegi" class="pt-2" >
							<b-table
								ref="spOrderJobsTable"
								striped
								responsive
								hover
								show-empty
								empty-text="Ni posegov"
								:fields="spOrderJobsTableProps.fields"
								:items="spOrderJobsTableProps_items"
								:current-page="spOrderJobsTableProps.currentPage"
								:per-page="spOrderJobsTableProps.itemsPerPage">
							</b-table>
							<nav v-if="showSpOrderJobsTableNav">
								<b-row>
									<b-col>
										<b-pagination :total-rows="spOrderJobsTableProps.totalItems" :per-page="spOrderJobsTableProps.itemsPerPage" v-model="spOrderJobsTableProps.currentPage" prev-text="Prejšnja" next-text="Naslednja" hide-goto-end-buttons />
									</b-col>
									<b-col cols=2>
										<a class="page-link rows_total float-right">Št. vrstic: {{ spOrderJobsTableProps.totalItems }}</a>
									</b-col>
									<b-col cols=1>
										<b-form-select v-model="spOrderJobsTableProps.itemsPerPage" :options="spOrderJobsTableProps.options_numRowsOnPage"></b-form-select>
									</b-col>
								</b-row>
							</nav>
							<vue-loading :active.sync="spOrderJobsTableProps.isLoading" :is-full-page="false"/>
						</b-tab>
					</b-tabs>
				</b-card>
			</CCol>
		</CRow>
		<CAlert v-show="message.text != null" :color="message.type">
			{{ message.text }}
		</CAlert>
		<template slot="modal-footer" slot-scope="{ cancel }">
			<b-container fluid class="p-0">
				<b-row>
					<b-col align-self="end" class="ma_pos">
						<b-button :disabled="isLoading" style="margin-right:5px;" variant="secondary" @click="cancel()">Zapri</b-button>
						<span v-if="permissionCheck.can('sp-orders-write')">
							<b-button v-if="editingRecord.type && isCurrentlyEdited() && !editingRecord.forced_edit" :disabled="isEditingDisabled()" :title="getEditingLockTitle()" variant="primary" @click.stop="click_spOrderForceEdit()" size="sm" class="mr-2">
								<CIcon name="cil-lock-locked"/>
							</b-button>
							<b-button v-else-if="mode != mode_UNKNOWN0" :disabled="isLoading || isSpOrderItemEditing" style="margin-right:5px;" variant="primary" @click="click_enableEditing()" :title="modalOkButtonData.title">{{ modalOkButtonData.label }}</b-button>
						</span>
					</b-col>
				</b-row>
			</b-container>
		</template>
		<vue-loading :active.sync="isLoading" :is-full-page="false"/>
		<sp-order-client-create-edit-modal ref="spOrderClientCreateEditModal" @emit_spOrderClientCreatedOrEdited="emit_spOrderClientCreatedOrEdited" @emit_spOrderClientModalCancel="emit_spOrderClientModalCancel"/>
		<sp-order-attachments-upload-modal ref="spOrderAttachmentUploadModal" @emit_spOrderAttachmentsSelected="emit_spOrderAttachmentsSelected"/>
		<sp-order-comment-create-modal ref="spOrderCommentCreateModal" @emit_spOrderCommentCreate="emit_spOrderCommentCreate"/>
		<replacement-vehicle-reservation-create-edit-modal ref="replacementVehicleReservationCreateEditModal" @emit_replacementVehicleReservationCreatedOrEdited="emit_replacementVehicleReservationCreatedOrEdited"/>
		<image-preview-modal ref="imagePreviewModal"/>
	</b-modal>
</template>

<script>
import axios from 'axios';
import settings from '@/settings.js';
import imagesTool from '@/tools/images';
import { SP_ORDER_CLIENTS_LIST_ALL, SP_ORDER_CLIENT_CREATE } from "@/store/actions/spOrderClients";
import { VEHICLE_BRANDS_LIST_ALL } from "@/store/actions/vehicleBrands";
import { SP_ORDER_CREATE, SP_ORDER_GET, SP_ORDER_SET_VIEWED, SP_ORDER_NUMBER_EXTERNAL_SEARCH, SP_ORDER_NUMBER_GET_EXTERNAL, SP_ORDERS_SEARCH_BY_SP_ORDER_NUMBER } from "@/store/actions/spOrders";
import { SP_ORDER_ITEM_CREATE, SP_ORDER_ITEMS_LIST_FILTERED, SP_ORDER_ITEM_DELETE, SP_ORDER_ITEM_CATALOG_NUMBER_EXTERNAL_SEARCH, SP_ORDER_ITEM_CHANGE_SP_ORDER } from "@/store/actions/spOrderItems";
import { VEHICLES_LIST_FILTERED } from "@/store/actions/vehicles";
import { EDITING_RECORD_START, EDITING_RECORD_END } from "@/store/actions/editingRecords";
import { SP_ORDER_COMMENTS_LIST_FILTERED } from "@/store/actions/spOrderComments";
import { SP_ORDER_JOBS_LIST_FILTERED } from "@/store/actions/spOrderJobs";
import { USERS_LIST_ALL_SP_ORDERERS } from "@/store/actions/users";
import { REPLACEMENT_VEHICLES_ALL } from "@/store/actions/replacementVehicles";
import { REPLACEMENT_VEHICLE_RESERVATION_DELETE } from "@/store/actions/replacementVehicleReservations";
import { SP_ORDER_ATTACHMENT_CREATE, SP_ORDER_ATTACHMENTS_LIST_FILTERED, SP_ORDER_ATTACHMENT_DELETE } from "@/store/actions/spOrderAttachments";
import { FILE_DOWNLOAD } from "@/store/actions/files";
import PermissionCheck from '@/tools/permission-check';
import _ from 'lodash';
import SpOrderItemEstimatedDateDropdown from '@/views/components/SpOrderItemEstimatedDateDropdown';
import SpOrderAttachmentUpload from '@/views/modals/SpOrderAttachmentUpload';
import SpOrderCommentCreate from '@/views/modals/SpOrderCommentCreate';
import { addDays, addSeconds } from 'date-fns';
const PH_TEXT = 'Izberi ali povleci datoteko ...';
import ReplacementVehicleReservationCreateEdit from '@/views/modals/ReplacementVehicleReservationCreateEdit';
import UserAvatar from '@/views/components/UserAvatar';
import ImagePreview from '@/views/modals/ImagePreview';

export default {
	name: 'sp-order-create-edit-modal',
	components: {
		'sp-order-item-estimated-date-dropdown': SpOrderItemEstimatedDateDropdown,
		'sp-order-attachments-upload-modal': SpOrderAttachmentUpload,
		'sp-order-comment-create-modal': SpOrderCommentCreate,
		'replacement-vehicle-reservation-create-edit-modal': ReplacementVehicleReservationCreateEdit,
		'user-avatar': UserAvatar,
		'image-preview-modal': ImagePreview
	},
	props: {
		allSpOrderers: {
			type: Array,
			required: true
		},
		allServiceAdvisors: {
			type: Array,
			required: true
		},
		allSpOrderClients: {
			type: Array,
			required: true
		},
	},
	methods: {
		showModal: function (modalInput) {
			/*
				mode 1 => Create
			*/
			this.spOrder.date = this.today.toISOString();
			this.mode = modalInput.mode;
			this.editingRecord.type = modalInput.editingRecordType ?? null;
			this.editingRecord.forced_edit = modalInput.forced_edit ?? false;
			this.initModal(modalInput.spOrder);
		},
		updateModalData: function (updatedSpOrder) {
			if (this.mode === this.mode_EDIT2) {
				// this.showAlert('Naročilo je spremenil drug uporabnik! Če želite posodobljene podatke zaprite in ponovno odprite naročilo.', this.ALERT_TYPE_ERROR);
			} else if (this.mode === this.mode_DETAILS3) {
				this.initSpOrder(updatedSpOrder);
				this.$refs.spOrderItemsTable.refresh();
			}
		},
		setViewedRecord: function (spOrderId) {
			this.startProgress();
			this.$store.dispatch(SP_ORDER_SET_VIEWED, { sp_order_id: spOrderId })
				.then((responseData) => {
					this.$emit('emit_spOrderSetView', responseData.userViewedSpOrder);
					this.stopProgress();
				})
				.catch(error => {
					this.stopProgress();
					console.error(error);
				});
		},
		initModal: function (spOrder) {
			if (this.mode === this.mode_CREATE1) {
				this.title = 'Dodajanje naročila ND';
				this.spOrderOkButton.title = 'Dodaj';
				this.spOrder.department = this.settings.spOrderDepartmentOptions[0];
				this.spOrder.location = this.settings.spOrderLocationOptions[0];
				this.isSpOrderEditing = true;
			} else if (this.mode === this.mode_EDIT2 && this.permissionCheck.can('sp-orders-write')) {
				this.newSpOrderItem.status = this.spOrderItemsStatusOptions[this.settings.newItemDefaultStatusIndex];
				this.newSpOrderItem.estimated_delivery_date = addDays(this.today, 1).toISOString();
				this.spOrderItemsTableProps.inputFilter.spOrderId = spOrder.id;
				this.spOrderCommentsTableProps.inputFilter.spOrderId = spOrder.id;
				this.spOrderAttachmentsTableProps.inputFilter.spOrderId = spOrder.id;
				this.spOrderJobsTableProps.inputFilter.spOrderId = spOrder.id;
				this.title = 'Urejanje naročila ND';
				this.spOrderOkButton.title = 'Shrani spremembe';
				this.initSpOrder(spOrder);
				if (this.editingRecord.type) {
					this.startProgress();
					this.$store.dispatch(EDITING_RECORD_START, { editingRecord: this.editingRecord })
						.then((responseData) => {
							this.stopProgress();
							if (responseData.editingRecord) {
								this.$emit('emit_spOrderChange');
								this.editingRecord.id = responseData.editingRecord.id;
							} else {
								this.$emit('emit_spOrderEditingRecordStartError');
								this.$refs.modal.hide();
							}
						})
						.catch(error => {
							this.stopProgress();
							this.$emit('emit_spOrderEditingRecordStartError');
							this.$refs.modal.hide();
							console.error(error);
						});
				}
			} else if (this.mode === this.mode_DETAILS3) {
				this.spOrderItemsTableProps.inputFilter.spOrderId = spOrder.id;
				this.spOrderCommentsTableProps.inputFilter.spOrderId = spOrder.id;
				this.spOrderJobsTableProps.inputFilter.spOrderId = spOrder.id;
				this.spOrderAttachmentsTableProps.inputFilter.spOrderId = spOrder.id;
				this.title = 'Naročilo #' + spOrder.id;
				this.okButton.label = 'Uredi';
				this.initSpOrder(spOrder);
			} else {
				this.mode = this.mode_UNKNOWN0;
				this.title = 'Neznan način';
				this.okButton.label = 'Zapri';
			}
			this.$refs.modal.show();
		},
		initSpOrder: function (spOrder) {
			if ((!spOrder.viewed_record || (spOrder.viewed_record && spOrder.viewed_record.viewed_at === null))) {
				this.setViewedRecord(spOrder.id);
			}
			this.spOrder.id = spOrder.id;
			this.spOrder.date = spOrder.date;
			this.spOrder.spOrderNumber = spOrder.sp_order_number;
			this.spOrder.department = spOrder.department;
			if (spOrder.vehicle) {
				this.spOrder.vin = spOrder.vehicle.ogrodje;
			}
			this.spOrder.registrationNumber = spOrder.registration_number;
			this.spOrder.brandId = spOrder.brand_id;
			this.selectedBrand = this.allVehicleBrands.find(brand => brand.id === spOrder.brand_id);
			this.spOrder.model = spOrder.model;
			this.spOrder.location = spOrder.location;
			this.spOrder.clientId = spOrder.client_id;
			this.selectedSpOrderClient = this.allSpOrderClients.find(client => client.id === spOrder.client_id);
			this.spOrder.serviceAdvisor = spOrder.service_advisor;
			this.spOrder.serviceAdvisorId = spOrder.service_advisor_id;
			this.selectedServiceAdvisor = this.allServiceAdvisors.find(serviceAdvisor => serviceAdvisor.id === spOrder.service_advisor_id);
			this.spOrder.warranty = this.settings.spOrderWarrantyOptions.find(option => option.value === spOrder.warranty);
			this.spOrder.pickupDate = spOrder.pickup_date;
			this.spOrder.priceDiscountedExclVat = spOrder.priceDiscountedExclVat;
			this.spOrder.ordered_by = spOrder.ordered_by;
			this.selectedOrderer = this.allSpOrderers.find(orderer => orderer.id === spOrder.ordered_by);
			let note = '';
			if (this.selectedOrderer) note = this.selectedOrderer.initials;
			if (this.spOrder.spOrderNumber) note += this.spOrder.spOrderNumber;
			if (note != '') this.newSpOrderItem.note = note;
			if (this.selectedSpOrderClient && spOrder.client && spOrder.client.updated_at != this.selectedSpOrderClient.updated_at) {
				this.startProgress();
				this.$store.dispatch(SP_ORDER_CLIENTS_LIST_ALL)
					.then((responseData) => {
						this.selectedSpOrderClient = this.allSpOrderClients.find(client => client.id === spOrder.client_id);
						this.stopProgress();
					})
					.catch(error => {
						console.error(error);
					});
			}
			if (this.editingRecord.type) {
				this.editingRecord.object_id = spOrder.id;
				this.spOrder.latestEditingRecord = spOrder.latest_editing_record;
			}
			if (spOrder.replacement_vehicle_reservation) {
				this.selectedReplacementVehicle = this.replacementVehicles.find(item => item.id === spOrder.replacement_vehicle_reservation.replacement_vehicle_id);
				this.currentReplacementVehicleReservation.id = spOrder.replacement_vehicle_reservation.id;
				this.currentReplacementVehicleReservation.replacementVehicleId = spOrder.replacement_vehicle_reservation.replacement_vehicle_id;
				this.currentReplacementVehicleReservation.spOrderId = spOrder.replacement_vehicle_reservation.sp_order_id;
				this.currentReplacementVehicleReservation.startsOn = spOrder.replacement_vehicle_reservation.starts_on;
				this.currentReplacementVehicleReservation.endsOn = spOrder.replacement_vehicle_reservation.ends_on;
			}
			if (spOrder.prepopulateSpOrderItem) {
				this.catalogNumberSearch(spOrder.prepopulateSpOrderItem.deliveredSpOrderItemCatalogNumber);
				this.newSpOrderItem.note = spOrder.prepopulateSpOrderItem.deliveredSpOrderItemNote;
				this.newSpOrderItem.connectToDelieredSpOrderItemId = spOrder.prepopulateSpOrderItem.deliveredSpOrderItemId;
				this.newSpOrderItem.status = this.spOrderItemsStatusOptions.at(-1);
				this.newSpOrderItem.estimated_delivery_date = null;
				this.newSpOrderItem.in_house = true;
			}
		},
		click_spOrderCreate: function () {
			this.startProgress();
			let spOrderData = {...this.spOrder};
			let isNewBrand = this.selectedBrand && this.selectedBrand.title && !this.selectedBrand.id;
			if (isNewBrand) {
				spOrderData.brandTitle = this.selectedBrand.title;
			}
			if (!spOrderData.spOrderNumber) {
				this.showAlert('Št. DN je obvezna!', this.ALERT_TYPE_ERROR, 5);
				this.stopProgress();
				return;
			}
			this.$store.dispatch(SP_ORDER_CREATE, { spOrder: spOrderData })
				.then((responseData) => {
					this.stopProgress();
					if (this.mode === this.mode_CREATE1) {
						this.$emit('emit_spOrderChange', responseData);
						this.showAlert('Naročilo #' + responseData.spOrder.id + ' uspešno dodano!', this.ALERT_TYPE_SUCCESS, 5);
						this.isSpOrderEditing = false;
						this.mode = this.mode_EDIT2;
						this.initModal(responseData.spOrder);
						if (isNewBrand) {
							this.$store.dispatch(VEHICLE_BRANDS_LIST_ALL)
								.then((vehicleBrandsResponseData) => {
									this.selectedBrand = this.allVehicleBrands.find(brand => brand.id === responseData.spOrder.brand_id);
									this.spOrder.brand_id = this.selectedBrand.id;
								})
								.catch(error => {
									console.error(error);
								});
						}
					} else if (this.mode === this.mode_EDIT2 && !this.editingRecord.type) {
						this.$emit('emit_spOrderChange', responseData);
					} else {
						this.$refs.modal.hide();
					}
				})
				.catch(error => {
					this.stopProgress();
					console.error(error);
					if(error.response && error.response.data && error.response.data.code) {
						if (this.mode === this.mode_CREATE1) {
							this.showAlert('Napaka pri dodajanju! (' + error.response.data.code + ')', this.ALERT_TYPE_ERROR);
						} else {
							this.showAlert('Neznan način modala! (' + error.response.data.code + ')', this.ALERT_TYPE_ERROR);
						}
					} else {
						this.showAlert('Napaka! Prosimo poizkusite kasneje.', this.ALERT_TYPE_ERROR);
					}
				});
		},
		clearModalData: function () {
			this.isLoading = false;
			this.title = '';
			this.okButton = {
				label: 'Shrani',
				progress: false,
				disabled: false
			};
			this.showAlert();
			if (this.mode === this.mode_EDIT2 && this.editingRecord.type) {
				this.$store.dispatch(EDITING_RECORD_END, { editingRecord: this.editingRecord })
					.then((responseData) => {
						this.$emit('emit_spOrderChange', responseData);
					})
					.catch(error => {
						console.error(error);
					});
			}
			this.mode = 0;
			this.resetSpOrderObject();
			this.resetSpOrderItemsTable();
			this.resetSpOrderItemObject();
			this.resetSpOrderCommentsTable();
			this.resetSpOrderJobsTable();
			this.resetReplacementVehicleReservationObject();
			this.isSpOrderItemEditing = false;
			this.vehicle_options = [];
			this.isSpOrderEditing = false;
			this.editingRecord = {
				id: null,
				type: null,
				object_id: null,
				data_at_start: null,
				forced_edit: false
			};
			this.catalogNumber_options = [];
			this.orderNumber_options = [];
			this.selectedTabIndex = 0;
			this.selectedReplacementVehicle = null;
			this.$emit('emit_spOrderModalClosed');
			this.tmpOrderAttachments = null;
			this.spOrderAttachmentsToUpload = [];
			this.spOrderAttachmentsToSave = [];
			this.resetSpOrderAttachmentsTable();
			this.movingSpOrderItemsInProgress = false;
			this.moveSpOrderItemsToSpOrder = null;
			this.spOrders_options = [];
		},
		resetSpOrderObject: function () {
			this.spOrder.id = null;
			this.spOrder.date = null;
			this.spOrder.spOrderNumber = null;
			this.spOrder.department = null;
			this.spOrder.vin = null;
			this.spOrder.registrationNumber = null;
			this.spOrder.brandId = null;
			this.spOrder.model = null;
			this.spOrder.location = null;
			this.spOrder.clientId = null;
			this.selectedSpOrderClient = null;
			this.selectedBrand = null;
			this.spOrder.latestEditingRecord = null;
			this.spOrder.serviceAdvisor = null;
			this.spOrder.serviceAdvisorId = null;
			this.selectedServiceAdvisor = null;
			this.spOrder.warranty = null;
			this.spOrder.pickupDate = null;
			this.spOrder.priceDiscountedExclVat = null;
			this.spOrder.ordered_by = null;
			this.selectedOrderer = null;
		},
		resetSpOrderItemsTable: function () {
			this.spOrderItemsTableProps.sortDesc = true;
			this.spOrderItemsTableProps.currentPage = 1;
			this.spOrderItemsTableProps.itemsPerPage = 20;
			this.spOrderItemsTableProps.totalItems = 0;
			this.spOrderItemsTableProps.inputFilter.spOrderId = null
			this.spOrderItemsTableProps.textFilterTimeout = null;
			this.spOrderItemsTableProps.errorText = '';
		},
		resetSpOrderItemObject: function () {
			this.newSpOrderItem.id = null;
			this.newSpOrderItem.sp_order_id = null;
			this.newSpOrderItem.catalog_number = null;
			this.newSpOrderItem.title = null;
			this.newSpOrderItem.status = null;
			this.newSpOrderItem.estimated_delivery_date = null;
			let note = (this.selectedOrderer ? this.selectedOrderer.initials : '') + this.spOrder.spOrderNumber ?? '';
			this.newSpOrderItem.note = note === '' ? null : note;
			this.newSpOrderItem.info = null;
			this.newSpOrderItem.stock = null;
			this.newSpOrderItem.in_house = false;
		},
		resetReplacementVehicleReservationObject: function () {
			this.currentReplacementVehicleReservation.id = null;
			this.currentReplacementVehicleReservation.replacementVehicleId = null
			this.currentReplacementVehicleReservation.spOrderId = null;;
			this.currentReplacementVehicleReservation.startsOn = null;
			this.currentReplacementVehicleReservation.endsOn = null;
		},
		startProgress: function () {
			this.isLoading = true;
			this.okButton.disabled = true;
			this.okButton.progress = true;
		},
		stopProgress: function () {
			this.isLoading = false;
			this.okButton.disabled = false;
			this.okButton.progress = false;
		},
		showAlert: function (message, type, seconds) {
			if (message && type && seconds) {
				this.message.type = type;
				this.message.text = message;
				setTimeout(() => {
					this.showAlert();
				}, seconds * 1000);
			} else if (message && type) {
				this.message.type = type;
				this.message.text = message;
			} else if (message) {
				this.message.type = 'primary';
				this.message.text = message;
			} else {
				this.message.type = null;
				this.message.text = null;
			}
		},
		change_spOrderClientsSelect: function (client, motiondata) {
			this.setSpOrderEditing();
			if (client) {
				if (client.id) {
					this.spOrder.clientId = client.id;
				} else {
					let defaultClient = this.getDefaultClient();
					if (motiondata === true) {
						if (client.company == false) {
							defaultClient.firstName = client.lastName;
							defaultClient.lastName = client.firstName;
						} else {
							defaultClient.companyTitle = client.name;
							defaultClient.isCompany = true;
						}
						defaultClient.city = client.city;
						defaultClient.cityCode = client.zipCode;
						defaultClient.email = client.email1;
						defaultClient.phoneNumber = client.mobile1 ?? client.phone1;
						defaultClient.street = client.email1;
						defaultClient.note = 'Stranka dodana iz motiondata';
					} else {
						let inputValue = client.first_name ?? client;
						let spaceIndex = inputValue.indexOf(' ');
						if(spaceIndex > -1) {
							defaultClient.firstName = inputValue.substring(0, spaceIndex)
							defaultClient.lastName = inputValue.substring(spaceIndex+1);
						} else {
							defaultClient.firstName = inputValue;
						}
					}
					this.startProgress();
					this.$store.dispatch(SP_ORDER_CLIENT_CREATE, { client: defaultClient })
						.then((responseData) => {
							this.spOrder.clientId = responseData.client.id;
							this.stopProgress();
							this.$store.dispatch(SP_ORDER_CLIENTS_LIST_ALL)
								.then(() => {
									if (motiondata) {
										this.selectedSpOrderClient = this.allSpOrderClients.find(client => client.id === responseData.client.id);
									}
								})
								.catch(error => {
									console.error(error);
								});
						})
						.catch(error => {
							this.stopProgress();
							console.error(error);
							if(error.response && error.response.data && error.response.data.code) {
								this.showAlert('Napaka pri dodajanju stranke! Prosimo poizkusite kasneje.', this.ALERT_TYPE_ERROR);
							} else {
								this.showAlert('Napaka pri dodajanju stranke! Prosimo poizkusite kasneje.', this.ALERT_TYPE_ERROR);
							}
						});
				}
			} else {
				this.spOrder.clientId = null;
			}
		},
		getDefaultClient: function () {
			return {
				firstName: '',
				lastName: '',
				isCompany: false
			};
		},
		click_editClient: function () {
			let modalInput = {
				mode: 2,
				client: this.selectedSpOrderClient
			}
			this.$refs.spOrderClientCreateEditModal.showModal(modalInput);
		},
		emit_spOrderClientCreatedOrEdited: function (data) {
			this.selectedSpOrderClient = data.client;
			this.change_spOrderClientsSelect(data.client);
			const searchEl = this.$refs.vSelectClient.searchEl;
			if (searchEl) {
				searchEl.blur();
			}
			this.$emit('emit_spOrderChange');
		},
		emit_spOrderClientModalCancel: function () {
			if (!this.selectedSpOrderClient.id) {
				this.selectedSpOrderClient = null;
			}
		},
		filter_clientsSelect: (option, label, search) => {
			let s = search.toLowerCase();
			if (option.is_company) {
				let text = (option.company_title ? option.company_title.toLowerCase() : '') + ' ' + (option.email ? option.email.toLowerCase() : '');
				let t = (text.indexOf(s) > -1);
				return t;
			} else {
				let text = (option.first_name ? option.first_name.toLowerCase() : '') + ' ' + (option.last_name ? option.last_name.toLowerCase() : '');
				let t = (text.indexOf(s) > -1);
				return t;
			}
		},
		filter_orderersSelect: (option, label, search) => {
			let s = search.toLowerCase();
			let name = (option.name ? option.name.toLowerCase() : '');
			let initials = (option.initials ? option.initials.toLowerCase() : '');
			let t = (name.indexOf(s) > -1) || (initials.indexOf(s) > -1);
			return t;
		},
		change_serviceAdvisorSelect: function (user) {
			this.setSpOrderEditing();
			if (user) {
				this.spOrder.serviceAdvisor = user.name.toUpperCase();
				this.spOrder.serviceAdvisorId = user.id;
			} else {
				this.spOrder.serviceAdvisor = null;
				this.spOrder.serviceAdvisorId = null;
			}
		},
		getClientSelectLabel: function(client, slot) {
			let label = '';
			if (!client) {
				return '';
			}
			if (client.is_company) {
				label += client.company_title ? client.company_title + ' ' : '';
				label += client.email ? '(' + client.email + ')' : '';
			} else {
				label += client.first_name ? client.first_name + ' ' : '';
				label += client.last_name ? client.last_name + ' ' : '';
				label += client.email ? '(' + client.email + ')' : '';
			}
			if (slot === 'selected-option' && label.length > 30) {
				return label.substring(0, 27) + '...';
			}
			return label;
		},
		spOrderItemsTable_items: function (ctx) {
			//this.spOrderItemsTableProps.isLoading = true;
			this.startProgress();
			return this.$store.dispatch(SP_ORDER_ITEMS_LIST_FILTERED, { ctx: ctx, tableProps: this.spOrderItemsTableProps })
				.then((responseData) => {
					this.stopProgress();
					//this.spOrderItemsTableProps.isLoading = false;
					this.spOrderItemsTableProps.items = responseData.spOrderItemsPagination.data.map(obj=> {
						let withNewPropertyes = ({ ...obj, edited: false });
						withNewPropertyes.status = this.spOrderItemsStatusOptions.find((item) => item.value === obj.status);
						return withNewPropertyes;
					});
					this.spOrderItemsTableProps.totalItems = responseData.spOrderItemsPagination.total;
					this.spOrderItemsTableProps.empty_text = 'Ni vnosov';
					return this.spOrderItemsTableProps.items;
				})
				.catch(error => {
					this.stopProgress();
					//this.spOrderItemsTableProps.isLoading = false;
					this.spOrderItemsTableProps.items = [];
					this.spOrderItemsTableProps.totalItems = 0;
					this.spOrderItemsTableProps.empty_text = 'Napaka pri pridobivanju postavk naročila';
					console.log(error);
					return [];
				});
		},
		spOrderCommentsTableProps_items: function (ctx) {
			this.startProgress();
			return this.$store.dispatch(SP_ORDER_COMMENTS_LIST_FILTERED, { ctx: ctx, tableProps: this.spOrderCommentsTableProps })
				.then((responseData) => {
					this.stopProgress();
					this.spOrderCommentsTableProps.items = responseData.spOrderCommentsPagination.data;
					this.spOrderCommentsTableProps.totalItems = responseData.spOrderCommentsPagination.total;
					this.spOrderCommentsTableProps.empty_text = 'Ni vnosov';
					return this.spOrderCommentsTableProps.items;
				})
				.catch(error => {
					this.stopProgress();
					this.spOrderCommentsTableProps.items = [];
					this.spOrderCommentsTableProps.totalItems = 0;
					this.spOrderCommentsTableProps.empty_text = 'Napaka pri pridobivanju komentarjev naročila';
					console.log(error);
					return [];
				});
		},
		resetSpOrderCommentsTable: function () {
			this.spOrderCommentsTableProps.sortDesc = true;
			this.spOrderCommentsTableProps.currentPage = 1;
			this.spOrderCommentsTableProps.itemsPerPage = 10;
			this.spOrderCommentsTableProps.totalItems = 0;
			this.spOrderCommentsTableProps.inputFilter.spOrderId = null
			this.spOrderCommentsTableProps.textFilterTimeout = null;
			this.spOrderCommentsTableProps.errorText = '';
		},
		spOrderJobsTableProps_items: function (ctx) {
			this.startProgress();
			return this.$store.dispatch(SP_ORDER_JOBS_LIST_FILTERED, { ctx: ctx, tableProps: this.spOrderJobsTableProps })
				.then((responseData) => {
					this.stopProgress();
					this.spOrderJobsTableProps.items = responseData.spOrderJobsPagination.data;
					this.spOrderJobsTableProps.totalItems = responseData.spOrderJobsPagination.total;
					this.spOrderJobsTableProps.empty_text = 'Ni vnosov';
					return this.spOrderJobsTableProps.items;
				})
				.catch(error => {
					this.stopProgress();
					this.spOrderJobsTableProps.items = [];
					this.spOrderJobsTableProps.totalItems = 0;
					this.spOrderJobsTableProps.empty_text = 'Napaka pri pridobivanju posegov naročila';
					console.log(error);
					return [];
				});
		},
		resetSpOrderJobsTable: function () {
			this.spOrderJobsTableProps.sortDesc = true;
			this.spOrderJobsTableProps.currentPage = 1;
			this.spOrderJobsTableProps.itemsPerPage = 10;
			this.spOrderJobsTableProps.totalItems = 0;
			this.spOrderJobsTableProps.inputFilter.spOrderId = null
			this.spOrderJobsTableProps.textFilterTimeout = null;
			this.spOrderJobsTableProps.errorText = '';
		},
		click_spOrderItemCreate: function(data) {
			this.startProgress();
			this.newSpOrderItem.sp_order_id = this.spOrder.id;
			this.$store.dispatch(SP_ORDER_ITEM_CREATE, { spOrderItem: this.newSpOrderItem })
				.then((responseData) => {
					this.stopProgress();
					this.resetSpOrderItemObject();
					this.$refs.spOrderItemsTable.refresh();
					this.$emit('emit_spOrderChange', responseData);
					this.showAlert('Postavka ' + responseData.spOrderItem.id + ' uspešno dodana!', this.ALERT_TYPE_SUCCESS, 5);
				})
				.catch(error => {
					this.stopProgress();
					console.error(error);
					if(error.response && error.response.data && error.response.data.code) {
						this.showAlert('Napaka pri dodajanju postavke! (' + error.response.data.code + ')', this.ALERT_TYPE_ERROR);
					} else {
						this.showAlert('Napaka! Prosimo poizkusite kasneje.', this.ALERT_TYPE_ERROR);
					}
				});
		},
		click_spOrderItemClear: function() {
			this.resetSpOrderItemObject();
		},
		click_enableEditing: function() {
			if (this.mode === this.mode_DETAILS3) {
				if (this.editingRecord.type) {
					this.startProgress();
					this.$store.dispatch(EDITING_RECORD_START, { editingRecord: this.editingRecord })
						.then((responseData) => {
							this.stopProgress();
							if (responseData.editingRecord) {
								this.$emit('emit_spOrderChange');
								this.editingRecord.id = responseData.editingRecord.id;
								this.mode = this.mode_EDIT2;
							} else {
								this.showAlert('Napaka pri začetku urejanja!', this.ALERT_TYPE_ERROR);
							}
						})
						.catch(error => {
							this.stopProgress();
							console.error(error);
							if(error.response && error.response.data && error.response.data.code) {
								this.showAlert('Napaka pri začetku urejanja! (' + error.response.data.code + ')', this.ALERT_TYPE_ERROR);
							} else {
								this.showAlert('Napaka! Prosimo poizkusite kasneje.', this.ALERT_TYPE_ERROR);
							}
						});
				} else {
					this.mode = this.mode_EDIT2;
				}
			} else {
				this.click_spOrderCreate();
			}
		},
		click_spOrderItemEdit: function(data) {
			this.startProgress();
			this.$store.dispatch(SP_ORDER_ITEM_CREATE, { spOrderItem: data })
				.then((responseData) => {
					this.stopProgress();
					this.$refs.spOrderItemsTable.refresh();
					this.$emit('emit_spOrderChange', responseData);
					this.showAlert('Postavka ' + responseData.spOrderItem.id + ' uspešno urejena!', this.ALERT_TYPE_SUCCESS, 5);
				})
				.catch(error => {
					this.stopProgress();
					console.error(error);
					if(error.response && error.response.data && error.response.data.code) {
						this.showAlert('Napaka pri urejanju postavke! (' + error.response.data.code + ')', this.ALERT_TYPE_ERROR);
					} else {
						this.showAlert('Napaka! Prosimo poizkusite kasneje.', this.ALERT_TYPE_ERROR);
					}
				});
		},
		click_spOrderItemCancel: function() {
			this.$refs.spOrderItemsTable.refresh();
		},
		click_spOrderItemRemove: function(data) {
			this.$bvModal.msgBoxConfirm('Želite izbrisati postavko #' + data.id + '?', {
				title: 'Potrdite brisanje postavke',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'DA',
				cancelTitle: 'NE',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(value => {
				if (value === true) {
					this.startProgress();
					this.$store.dispatch(SP_ORDER_ITEM_DELETE, { id: data.id })
						.then((responseData) => {
							this.stopProgress();
							this.showAlert('Postavka ' + data.id + ' uspešno izbrisana!', this.ALERT_TYPE_SUCCESS, 5);
							this.$emit('emit_spOrderChange', responseData);
							this.$refs.spOrderItemsTable.refresh();
						})
						.catch(error => {
							this.stopProgress();
							this.isLoading = false;
							console.error(error);
							if(error.response && error.response.data && error.response.data.code) {
								this.$refs.toastr.e('Napaka pri brisanju postavke! (' + error.response.data.code + ')');
							} else {
								this.$refs.toastr.e('Napaka pri brisanju postavke! Prosimo poizkusite kasneje.');
							}
						});
				}
			}).catch(err => {
				console.error(err);
			});
		},
		setSpOrderItemEditing: function(data) {
			data.edited = true;
		},
		spOrderItemInHouseChange: function(data) {
			data.in_house = !data.in_house;
			if (data.in_house) {
				data.status = this.spOrderItemsStatusOptions.at(-1);
			} else {
				data.status = null;
			}
			this.click_spOrderItemEdit(data);
		},
		newSpOrderItemInHouseChange: function() {
			this.newSpOrderItem.in_house = !this.newSpOrderItem.in_house;
			if (this.newSpOrderItem.in_house) {
				this.newSpOrderItem.status = this.spOrderItemsStatusOptions.at(-1);
			} else {	
				this.newSpOrderItem.status = null;
			}
		},
		setSpOrderEditing: function() {
			this.isSpOrderEditing = true;
		},
		click_spOrderEditCancel: function() {
			this.startProgress();
			this.$store.dispatch(SP_ORDER_GET, { id: this.spOrder.id })
				.then((responseData) => {
					this.stopProgress();
					this.isSpOrderEditing = false;
					this.initSpOrder(responseData.spOrder);
				})
				.catch(error => {
					this.stopProgress();
					console.error(error);
					if(error.response && error.response.data && error.response.data.code) {
						this.showAlert('Napaka pri pridobivanju naročila! (' + error.response.data.code + ')', this.ALERT_TYPE_ERROR);
					} else {
						this.showAlert('Napaka pri pridobivanju naročila! Prosimo poizkusite kasneje.', this.ALERT_TYPE_ERROR);
					}
				}); 
		},
		isEditingSpOrderItemDisabled: function(data) {
			if (data.edited) {
				this.isSpOrderItemEditing = true;
				return false;
			} else if (this.spOrderItemsTableProps.items.some(item => item.edited === true)) {
				this.isSpOrderItemEditing = true;
				return true;
			}
			this.isSpOrderItemEditing = false;
			return false;
		},
		getEstimatedDeliveryDateLabel: function(item) {
			if (item.estimated_delivery_date != null) {
				let date = new Date(item.estimated_delivery_date);
				if (date.getHours() === 21
					&& date.getMinutes() === 55
					&& date.getSeconds() === 0
					&& date.getMilliseconds() === 0) {
					return 'V Franciji';
				}
				let tommorow = new Date();
				tommorow = addDays(tommorow, 1);
				if (date.toLocaleDateString() === tommorow.toLocaleDateString()) {
					return 'JUTRI';
				}
				return this.$options.filters.viewDate(item.estimated_delivery_date);
			}
			return 'Ni roka';
		},
		change_brandsSelect: function (brand) {
			this.setSpOrderEditing();
			if (brand) {
				this.spOrder.brandId = brand.id;
			} else {
				this.spOrder.brandId = null;
			}
		},
		filter_brandsSelect: (option, label, search) => {
			let s = search.toLowerCase();
			let text = option.title ? option.title.toLowerCase() : ''
			let t = text.indexOf(s) > -1;
			return t;
		},
		getLocationLabel: function(location, slot) {
			let label = location.label;
			if (slot === 'selected-option' && label.length > 18) {
				return label.substring(0, 15) + '...';
			}
			return label;
		},
		vozilaSelect_load: _.debounce((loading, search, context) => {
			loading(true);
			context.$store.dispatch(VEHICLES_LIST_FILTERED, search )
				.then((responseData) => {
					loading(false);
					context.vehicle_options = responseData.items;
				})
				.catch(error => {
					loading(false);
					if(error.response && error.response.data && error.response.data.code) {
						context.showAlert('Napaka pri pridobivanju vozil! (' + error.response.data.code + ')', context.ALERT_TYPE_ERROR);
					} else {
						context.showAlert('Napaka pri pridobivanju vozil! Prosimo poizkusite kasneje.', context.ALERT_TYPE_ERROR);
					}
				});
		}, 500),
		vehicleSelect_search: function (search, loading) {
			if (search && search !== '') {
				this.vozilaSelect_load(loading, search, this);
			}
		},
		vehicleSelect_change: function (value) {
			this.setSpOrderEditing();
			if (value) {
				if (value.ogrodje) {
					this.spOrder.vin = value.ogrodje;
					this.spOrder.model = value.model;
					this.spOrder.brandId = value.brand_id;
					this.selectedBrand = this.allVehicleBrands.find(brand => brand.id === value.brand_id);
				} else {
					this.spOrder.vin = value;
				}
			} else {
				this.spOrder.vin = null;
			}
		},
		newSpOrderItemEstimatedDateInput: function (value) {
		},
		copyToCliboard: function (value, prop) {
			navigator.clipboard.writeText(value);
			if (prop === 'spOrderNumber') {
				this.spOrderNumberCopied = true;
				setTimeout(() => {
					this.spOrderNumberCopied = false;
				}, 2000);
				this.vinCopied = false;
				this.registrationNumberCopied = false;
			} else if (prop === 'vin') {
				this.vinCopied = true;
				setTimeout(() => {
					this.vinCopied = false;
				}, 2000);
				this.spOrderNumberCopied = false;
				this.registrationNumberCopied = false;
			} else if (prop === 'registrationNumber') {
				this.registrationNumberCopied = true;
				setTimeout(() => {
					this.registrationNumberCopied = false;
				}, 2000);
				this.spOrderNumberCopied = false;
				this.vinCopied = false;
			}
		},
		spOrderItemStatusChange: function(data) {
			if (data.status === this.spOrderItemsStatusOptions.at(-1)) {
				data.in_house = true;
			} else {
				data.in_house = false;
			}
			this.click_spOrderItemEdit(data);
		},
		newSpOrderItemStatusChange: function() {
			if (this.newSpOrderItem.status === this.spOrderItemsStatusOptions.at(-1)) {
				this.newSpOrderItem.in_house = true;
			} else {
				this.newSpOrderItem.in_house = false;
			}
		},
		getStatusTitle: function (item) {
			if (item.status === this.spOrderItemsStatusOptions.at(-1)) {
				return this.$options.filters.viewDateTime(item.in_house_setted_at);
			}
			return '';
		},
		isCurrentlyEdited: function () {
			if (!this.spOrder.latestEditingRecord) return false;
			if (this.spOrder.latestEditingRecord.ended_at != null) return false;
			let now = new Date();
			let limit = new Date(this.spOrder.latestEditingRecord.started_at);
			let limitTime = addSeconds(limit, this.editingRecord.type.show_lock_length);
			if (now > limitTime) return false;
			return true;
		},
		isEditingDisabled: function () {
			if (!this.spOrder.latestEditingRecord) return false;
			if (this.spOrder.latestEditingRecord.ended_at != null) return false;
			if (this.spOrder.latestEditingRecord.started_by_user.id === this.profile.id) return false;
			let now = new Date();
			let limit = new Date(this.spOrder.latestEditingRecord.started_at);
			let limitTime = addSeconds(limit, this.editingRecord.type.lock_length);
			if (now > limitTime) return false;
			return true;
		},
		getEditingLockTitle: function () {
			return 'Naročilo je začel urejati ' + this.spOrder.latestEditingRecord.started_by_user.name + ' dne ' + this.$options.filters.viewDate(this.spOrder.latestEditingRecord.started_at) + ' ob ' + this.$options.filters.viewTime(this.spOrder.latestEditingRecord.started_at);
		},
		click_spOrderForceEdit: function () {
			this.$bvModal.msgBoxConfirm('Naročilo #' + this.spOrder.id + ' ureja ' + this.spOrder.latestEditingRecord.started_by_user.name + '! Želite vseeno urediti naročilo?', {
				title: 'Potrdite urejanje naročila ND',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'DA',
				cancelTitle: 'NE',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(value => {
				if (value === true) {
					this.editingRecord.forced_edit = true;
					this.click_enableEditing();
				}
			}).catch(err => {
				console.error(err);
			})
		},
		catalogNumberSelect_load: _.debounce((loading, search, context) => {
			loading(true);
			context.$store.dispatch(SP_ORDER_ITEM_CATALOG_NUMBER_EXTERNAL_SEARCH, search)
				.then((responseData) => {
					loading(false);
					context.catalogNumber_options = responseData.items;
				})
				.catch(error => {
					loading(false);
					if(error.response && error.response.data && error.response.data.code) {
						context.showAlert('Napaka pri pridobivanju kataloških številk! (' + error.response.data.code + ')', context.ALERT_TYPE_ERROR);
					} else {
						context.showAlert('Napaka pri pridobivanju kataloških številk! Prosimo poizkusite kasneje.', context.ALERT_TYPE_ERROR);
					}
				});
		}, 500),
		catalogNumberSelect_search: function (search, loading) {
			if (search && search !== '' && search.length >= this.motiondataConfig().catalogNumberSearch.minInputLength) {
				this.catalogNumberSelect_load(loading, search, this);
			}
		},
		catalogNumberSelect_change: function (value) {
			if (value) {
				if (value.partNumber) {
					this.newSpOrderItem.catalog_number = value.partNumber;
					this.newSpOrderItem.title = value.description;
				} else {
					this.newSpOrderItem.catalog_number = value;
				}
			} else {
				this.newSpOrderItem.catalog_number = null;
			}
		},
		catalogNumberSearch: function (search) {
			this.startProgress();
			this.$store.dispatch(SP_ORDER_ITEM_CATALOG_NUMBER_EXTERNAL_SEARCH, search)
				.then((responseData) => {
					this.stopProgress();
					if (responseData.items.length != 1) {
						this.catalogNumber_options = responseData.items;
						this.showAlert('Rezultat iskanja kataloških številk ni vrnil 1 rezultat, prosimo preverite kataloško številko!', this.ALERT_TYPE_WARNING, 5);
						return;
					}
					this.catalogNumberSelect_change(responseData.items[0]);
				})
				.catch(error => {
					this.stopProgress();
					this.catalogNumber_options = [];
					if(error.response && error.response.data && error.response.data.code) {
						this.showAlert('Napaka pri pridobivanju kataloških številk! (' + error.response.data.code + ')', this.ALERT_TYPE_ERROR);
					} else {
						this.showAlert('Napaka pri pridobivanju kataloških številk! Prosimo poizkusite kasneje.', this.ALERT_TYPE_ERROR);
					}
				});
		},
		orderNumberSelect_load: _.debounce((loading, search, context) => {
			loading(true);
			context.$store.dispatch(SP_ORDER_NUMBER_EXTERNAL_SEARCH, search)
				.then((responseData) => {
					loading(false);
					context.orderNumber_options = responseData.items;
				})
				.catch(error => {
					loading(false);
					if(error.response && error.response.data && error.response.data.code) {
						context.showAlert('Napaka pri pridobivanju št. DN! (' + error.response.data.code + ')', context.ALERT_TYPE_ERROR);
					} else {
						context.showAlert('Napaka pri pridobivanju št. DN! Prosimo poizkusite kasneje.', context.ALERT_TYPE_ERROR);
					}
				});
		}, 500),
		orderNumberSelect_search: function (search, loading) {
			if (search && search !== '' && search.length >= this.motiondataConfig().orderNumberSearch.minInputLength) {
				this.orderNumberSelect_load(loading, search, this);
			}
		},
		orderNumberSelect_change: function (value) {
			if (value) {
				if (value.internalId) {
					this.getSpOrderExternalData(value.orderNumber);
				} else {
					this.spOrder.spOrderNumber = value.orderNumber;
				}
			} else {
				this.resetSpOrderNumberSelect();
			}
		},
		getSpOrderExternalData: function (orderNumber) {
			this.startProgress();
			this.$store.dispatch(SP_ORDER_NUMBER_GET_EXTERNAL, { orderNumber })
				.then((responseData) => {
					if (responseData.existingSpOrder && this.mode === this.mode_CREATE1) {
						this.showAlert('DN št. ' + orderNumber + ' že obstaja!', this.ALERT_TYPE_ERROR);
						this.resetSpOrderNumberSelect();
						this.stopProgress();
						return;
					}
					this.stopProgress();
					this.spOrder.spOrderNumber = orderNumber;
					if (this.selectedOrderer) this.newSpOrderItem.note = this.selectedOrderer.initials + this.spOrder.spOrderNumber;
					if (responseData.autoArchiveSpOrder) this.$emit('emit_spOrderChange', 'autoArchiveSpOrder');
					if (Object.hasOwn(responseData, 'motiondataOrder')) {
						let motiondataOrder = responseData.motiondataOrder;
						if (Object.hasOwn(motiondataOrder, 'vehicle')) {
							this.spOrder.vin = motiondataOrder.vehicle.vin;
							this.spOrder.registrationNumber = motiondataOrder.vehicle.numberPlate;
							this.spOrder.model = motiondataOrder.vehicle.modelDescription;
							this.selectedBrand = this.allVehicleBrands.find(brand => brand.title === motiondataOrder.vehicle.makeDescription);
							if (this.selectedBrand) this.spOrder.brand_id = this.selectedBrand.id;
						}
						if (Object.hasOwn(motiondataOrder, 'customer')) {
							this.selectedSpOrderClient = this.allSpOrderClients.find(client => 
								motiondataOrder.customer.company ? 
									(client.first_name + ' ' + client.last_name == motiondataOrder.customer.name || client.company_title == motiondataOrder.customer.name) :
									client.first_name === motiondataOrder.customer.firstName && client.last_name === motiondataOrder.customer.lastName
								&& client.email === motiondataOrder.customer.email1);
							if (this.selectedSpOrderClient) this.spOrder.clientId = this.selectedSpOrderClient.id;
							else this.change_spOrderClientsSelect(motiondataOrder.customer, true);
						}
						if (Object.hasOwn(motiondataOrder, 'serviceAdvisor')) {
							this.spOrder.serviceAdvisor = motiondataOrder.serviceAdvisor.lastName;
							this.selectedServiceAdvisor = this.allServiceAdvisors.find(serviceAdvisor => serviceAdvisor.name.toUpperCase() === motiondataOrder.serviceAdvisor.lastName);	
							this.spOrder.serviceAdvisorId = this.selectedServiceAdvisor.id;
						}
						if (Object.hasOwn(motiondataOrder, 'prices')) {
							if (Object.hasOwn(motiondataOrder.prices, 'priceTotal')) {
								this.spOrder.priceDiscountedExclVat = motiondataOrder.prices.priceTotal.priceDiscountedExclVat;
							}
						}
						this.spOrder.pickupDate = motiondataOrder.pickupDate;
					}
					this.showAlert();
				})
				.catch(error => {
					this.stopProgress();
					console.error(error);
					if(error.response && error.response.data && error.response.data.code) {
						this.showAlert('Napaka pri pridobivanju naročila iz motiondata! (' + error.response.data.code + ')', this.ALERT_TYPE_ERROR);
						} else {
						this.showAlert('Napaka pri pridobivanju naročila iz motiondata! Prosimo poizkusite kasneje.', this.ALERT_TYPE_ERROR);
					}
				});
		},
		resetSpOrderNumberSelect: function () {
			this.spOrder.spOrderNumber = null;
			this.newSpOrderItem.note = null;
			if (this.selectedOrderer) this.newSpOrderItem.note = this.selectedOrderer.initials;
		},
		change_ordererSelect: function (user) {
			this.setSpOrderEditing();
			if (user) {
				this.spOrder.ordered_by = user.id;
				this.newSpOrderItem.note = user.initials + (this.spOrder.spOrderNumber ?? '');
			} else {
				this.spOrder.ordered_by = null;
				this.newSpOrderItem.note = this.spOrder.spOrderNumber ?? null;
			}
		},
		click_addSpOrderAttachment: function () {
			this.$refs.spOrderAttachmentUploadModal.showModal();
		},
		emit_spOrderAttachmentsSelected: function (selectedFiles) {
			this.selectedTabIndex = 2;
			this.spOrderAttachmentsTableProps.isLoading = true;
			for (let attachment of selectedFiles) {
				this.spOrderAttachmentsToUpload.push(attachment);
				this.uploadFile(this, attachment);
			}
		},
		uploadFile: function (ctx, file) {
			this.spOrderAttachmentsTableProps.isLoading = true;
			let args = new FormData();
			let settings = {
				headers: {
					'content-type': 'multipart/form-data'
				},
				onUploadProgress: function(progressEvent) {
					let loadedPrecent = progressEvent.loaded / progressEvent.total * 100;
					let orderAttachment = ctx.spOrderAttachmentsToUpload.find(pril => pril.name === file.name);
					orderAttachment.progress = loadedPrecent;
					ctx.$refs.uploadSpOrderAttachmentsTable.refresh();
				}
			};
			args.append('file', file);
			return axios.post('/files/upload', args, settings)
				.then(response => {
					let attachment = {
						orginal_filename: response.data.orginal_filename,
						server_side_filename: response.data.server_side_filename,
						filepath: response.data.filepath,
						type: response.data.type,
					}
					this.spOrderAttachmentsToSave.push(attachment);
					if (this.spOrderAttachmentsToUpload.length === this.spOrderAttachmentsToSave.length) {
						this.saveSpOrderAttachemnts();
					}
					return response.data;
				})
				.catch(error => {
					if (error) {
						console.log(error);
					}
				});
		},
		saveSpOrderAttachemnts: function() {
			setTimeout(() => {
				this.$store.dispatch(SP_ORDER_ATTACHMENT_CREATE, { sp_order_id: this.spOrder.id, spOrderAttachments: this.spOrderAttachmentsToSave})
					.then((responseData) => {
						this.spOrderAttachmentsTableProps.isLoading = false;
						this.spOrderAttachmentsToUpload = [];
						this.spOrderAttachmentsToSave = [];
						this.$emit('emit_spOrderChange', responseData);
						this.$refs.spOrderAttachmentsTable.refresh();
						this.showAlert('Priloge uspešno naložene!', this.ALERT_TYPE_SUCCESS, 5);
					})
					.catch(error => {
						this.spOrderAttachmentsTableProps.isLoading = false;
						console.error(error);
						if(error.response && error.response.data && error.response.data.code) {
							this.showAlert('Napaka pri dodajanju prilog! (' + error.response.data.code + ')', this.ALERT_TYPE_ERROR);
						} else {
							this.showAlert('Napaka! Prosimo poizkusite kasneje.', this.ALERT_TYPE_ERROR);
						}
					});
			}, 500);
		},
		removeSpOrderAttachmentRetrieved_click: function (data) {
			this.$bvModal.msgBoxConfirm('Želite izbrisati prilogo ' + data.server_side_filename + '?', {
				title: 'Potrdite brisanje priloge',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'DA',
				cancelTitle: 'NE',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(value => {
				if (value === true) {
					this.spOrderAttachmentsTableProps.isLoading = true;
					this.$store.dispatch(SP_ORDER_ATTACHMENT_DELETE, { id: data.id })
						.then((responseData) => {
							this.spOrderAttachmentsTableProps.isLoading = false;
							this.showAlert('Priloga ' + data.server_side_filename + ' uspešno izbrisana!', this.ALERT_TYPE_SUCCESS, 5);
							this.$emit('emit_spOrderChange', responseData);
							this.$refs.spOrderAttachmentsTable.refresh();
						})
						.catch(error => {
							this.spOrderAttachmentsTableProps.isLoading = false;
							console.error(error);
							if(error.response && error.response.data && error.response.data.code) {
								this.$refs.toastr.e('Napaka pri brisanju priloge! (' + error.response.data.code + ')');
							} else {
								this.$refs.toastr.e('Napaka pri brisanju priloge! Prosimo poizkusite kasneje.');
							}
						});
				}
			}).catch(err => {
				console.error(err);
			});
		},
		spOrderAttachmentsTableProps_items: function (ctx) {
			this.startProgress();
			return this.$store.dispatch(SP_ORDER_ATTACHMENTS_LIST_FILTERED, { ctx: ctx, tableProps: this.spOrderAttachmentsTableProps })
				.then((responseData) => {
					this.stopProgress();
					this.spOrderAttachmentsTableProps.items = responseData.spOrderAttachmentsPagination.data
					this.spOrderAttachmentsTableProps.totalItems = responseData.spOrderAttachmentsPagination.total;
					this.spOrderAttachmentsTableProps.empty_text = 'Ni vnosov';
					return this.spOrderAttachmentsTableProps.items;
				})
				.catch(error => {
					this.stopProgress();
					this.spOrderAttachmentsTableProps.items = [];
					this.spOrderAttachmentsTableProps.totalItems = 0;
					this.spOrderAttachmentsTableProps.empty_text = 'Napaka pri pridobivanju prilog naročila';
					console.log(error);
					return [];
				});
		},
		resetSpOrderAttachmentsTable: function () {
			this.spOrderAttachmentsTableProps.sortDesc = true;
			this.spOrderAttachmentsTableProps.currentPage = 1;
			this.spOrderAttachmentsTableProps.itemsPerPage = 10;
			this.spOrderAttachmentsTableProps.totalItems = 0;
			this.spOrderAttachmentsTableProps.inputFilter.spOrderId = null
			this.spOrderAttachmentsTableProps.textFilterTimeout = null;
			this.spOrderAttachmentsTableProps.errorText = '';
		},
		downloadSpOrderAttachment_click: function (item) {
			this.startProgress();
			return this.$store.dispatch(FILE_DOWNLOAD, { filepath: item.filepath })
				.then((response) => {
					this.stopProgress();
					var newBlob = new Blob([response.data], {type: response.headers['content-type']});
					const data = window.URL.createObjectURL(newBlob);
					var link = document.createElement('a');
					link.href = data;
					link.download = item.orginal_filename;
					link.click();
					setTimeout(function () {
						// For Firefox it is necessary to delay revoking the ObjectURL
						window.URL.revokeObjectURL(data)
					}, 100);
				})
				.catch(error => {
					this.stopProgress();
					console.log(error);
					this.showAlert('Napaka! Prosimo poizkusite kasneje.', this.ALERT_TYPE_ERROR);
				});
		},
		showImage_click: function (item) {
			let modalInput = {
				src: item.src,
				title: item.orginal_filename
			}
			this.$refs.imagePreviewModal.showModal(modalInput);
		},
		click_openSpOrderCommentCreateModal: function () {
			let modalInput = {
				spOrderId: this.spOrder.id
			}
			this.$refs.spOrderCommentCreateModal.showModal(modalInput);
		},
		emit_spOrderCommentCreate: function (responseData) {
			this.selectedTabIndex = 1;
			this.$emit('emit_spOrderChange');
			this.showAlert('Komentar ' + responseData.spOrderComment.id + ' uspešno dodan!', this.ALERT_TYPE_SUCCESS, 5);
			this.$refs.spOrderCommentsTable.refresh();
		},
		change_replacementVehicleSelect: function (option) {
			this.setSpOrderEditing();
			if (option) {
				let replacementVehicleReservation = { replacementVehicleId: option.id, spOrder: this.spOrder } ;
				let modalInput = {
					mode: 1, // create
					replacementVehicleReservation,
					replacementVehicleVin: option.vin,
					issuedButNotFinishedReservation: option.issued_but_not_finished_reservation
				}
				this.$refs.replacementVehicleReservationCreateEditModal.showModal(modalInput);
			} else {
				this.replacementVehicleResevartionRemove(this.currentReplacementVehicleReservation);
			}
		},
		emit_replacementVehicleReservationCreatedOrEdited: function (data) {
			this.startProgress();
			this.$store.dispatch(REPLACEMENT_VEHICLES_ALL)
				.then((responseData) => {
					this.stopProgress();
					this.replacementVehicles = responseData.replacementVehicles;
				})
				.catch(error => {
					console.error(error);
			});
			this.currentReplacementVehicleReservation.id = data.replacementVehicleReservation.id;
			this.currentReplacementVehicleReservation.replacementVehicleId = data.replacementVehicleReservation.replacement_vehicle_id;
			this.currentReplacementVehicleReservation.startsOn = data.replacementVehicleReservation.starts_on;
			this.currentReplacementVehicleReservation.endsOn = data.replacementVehicleReservation.ends_on;
			this.$emit('emit_spOrderChange');
		},
		replacementVehicleResevartionRemove: function(data) {
			this.$bvModal.msgBoxConfirm('Želite izbrisati rezervacijo nadomestnega vozila #' + data.id + '?', {
				title: 'Potrdite brisanje rezervacije nadomestnega vozila',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'DA',
				cancelTitle: 'NE',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(value => {
				if (value === true) {
					this.startProgress();
					this.$store.dispatch(REPLACEMENT_VEHICLE_RESERVATION_DELETE, { id: data.id })
						.then((responseData) => {
							this.$store.dispatch(REPLACEMENT_VEHICLES_ALL)
								.then((responseData) => {
									this.stopProgress();
									this.replacementVehicles = responseData.replacementVehicles;
									this.showAlert('Rezevracijna nadomestnega vozila ' + data.id + ' uspešno izbrisana!', this.ALERT_TYPE_SUCCESS, 5);
									this.$emit('emit_spOrderChange', responseData);
									this.resetReplacementVehicleReservationObject();
								})
								.catch(error => {
									console.error(error);
							});
						})
						.catch(error => {
							this.stopProgress();
							this.isLoading = false;
							console.error(error);
							if(error.response && error.response.data && error.response.data.code) {
								this.$refs.toastr.e('Napaka pri brisanju rezevracijne nadomestnega vozila! (' + error.response.data.code + ')');
							} else {
								this.$refs.toastr.e('Napaka pri brisanju rezevracijne nadomestnega vozila! Prosimo poizkusite kasneje.');
							}
						});
				} else {
					this.selectedReplacementVehicle = this.replacementVehicles.find(item => item.id === this.currentReplacementVehicleReservation.replacementVehicleId);
				}
			}).catch(err => {
				console.error(err);
			});
		},
		getReplacementVehicleStatus: function (option) {
			let today = new Date();
			today.setUTCHours(0,0,0,0);
			let startsOn = new Date(option.latest_reservation.starts_on);
			let endsOn = new Date(option.latest_reservation.ends_on);
			if (startsOn > today || endsOn < today) return { variant: 'success'};
			else return { variant: 'danger'};
		},
		click_changeSpOrder: function () {
			if (!this.movingSpOrderItemsInProgress) {
				this.movingSpOrderItemsInProgress = true;
				return;
			}
			this.changeSpOrder();
		},
		click_cancelChangeSpOrder: function () {
			this.resetMovingSpOrderItems();
		},
		changeSpOrder: function () {
			if (!this.moveSpOrderItemsToSpOrder) {
				this.showAlert('Nalog na katerega se bo naredil prenos je obvezen', this.ALERT_TYPE_ERROR, 4);
				return;
			}
			const spOrderItemsToMoveIds = this.spOrderItemsTableProps.items.filter(obj => obj.selected).map(obj => obj.id);
			if (spOrderItemsToMoveIds.length < 1) {
				this.showAlert('Prosimo označite postavke, ki jih želite prenest.', this.ALERT_TYPE_ERROR, 4);
				return;
			}
			const data = {
				newSpOrderId: this.moveSpOrderItemsToSpOrder.id,
				spOrderItemsToMoveIds
			};
			this.startProgress();
			this.$store.dispatch(SP_ORDER_ITEM_CHANGE_SP_ORDER, data)
				.then((responseData) => {
					if (responseData.errorMovingSpOrderItemIds.length > 0) {
						this.showAlert('Napaka pri prenosu postavk z idji: ' + responseData.errorMovingSpOrderItemIds.map(obj => obj.id).join(','), this.ALERT_TYPE_ERROR);
					}
					this.showAlert('Nov delovni nalog: ' + this.moveSpOrderItemsToSpOrder.sp_order_number + ' Število premaknjenih postavk: ' + responseData.movedSpOrderItemsIds.length, this.ALERT_TYPE_SUCCESS);
					this.stopProgress();
					this.resetMovingSpOrderItems();
				})
				.catch(error => {
					this.stopProgress();
					this.resetMovingSpOrderItems();
					if(error.response && error.response.data && error.response.data.code) {
						this.showAlert('Napaka pri prenosu postavk! (' + error.response.data.code + ')', this.ALERT_TYPE_ERROR);
					} else {
						this.showAlert('Napaka pri prenosu postavk! Prosimo poizkusite kasneje.', this.ALERT_TYPE_ERROR);
					}
				});
		},
		resetMovingSpOrderItems: function()  {
			this.movingSpOrderItemsInProgress = false;
			this.moveSpOrderItemsToSpOrder = null;
			this.$refs.spOrderItemsTable.refresh();
		},
		spOrdersSelect_load: _.debounce((loading, search, context) => {
			loading(true);
			context.$store.dispatch(SP_ORDERS_SEARCH_BY_SP_ORDER_NUMBER, search )
				.then((responseData) => {
					loading(false);
					context.spOrders_options = responseData.items.filter(obj => obj.id !== context.spOrder.id);
				})
				.catch(error => {
					loading(false);
					if(error.response && error.response.data && error.response.data.code) {
						context.showAlert('Napaka pri pridobivanju naročil ND! (' + error.response.data.code + ')', context.ALERT_TYPE_ERROR);
					} else {
						context.showAlert('Napaka pri pridobivanju naročil ND! Prosimo poizkusite kasneje.', context.ALERT_TYPE_ERROR);
					}
				});
		}, 500),
		spOrderSelect_search: function (search, loading) {
			if (search && search !== '') {
				this.spOrdersSelect_load(loading, search, this);
			}
		},
		spOrderSelect_change: function (spOrder) {
			if (spOrder) {
				this.moveSpOrderItemsToSpOrder = spOrder;
			} else {
				this.moveSpOrderItemsToSpOrder = null;
			}
			this.spOrders_options = [];
		},
	},
	data: function () {
		return {
			settings,
			imagesTool,
			isLoading: false,
			title: '',
			okButton: {
				label: 'Shrani',
				progress: false,
				disabled: false
			},
			message: {
				type: null,
				text: null
			},
			ALERT_TYPE_SUCCESS: 'success',
			ALERT_TYPE_ERROR: 'danger',
			ALERT_TYPE_WARNING: 'warning',
			mode_UNKNOWN0: 0,
			mode_CREATE1: 1,
			mode_EDIT2: 2,
			mode_DETAILS3: 3,
			mode: 0,
			spOrder: {
				id: null,
				date: null,
				spOrderNumber: null,
				department: null,
				vin: null,
				registrationNumber: null,
				location: null,
				brandId: null,
				model: null,
				clientId: null,
				latestEditingRecord: null,
				serviceAdvisor: null,
				serviceAdvisorId: null,
				warranty: null,
				pickupDate: null,
				priceDiscountedExclVat: null,
				ordered_by: null
			},
			selectedSpOrderClient: null,
			spOrderItemsTableProps: {
				sortDesc: true,
				currentPage: 1,
				itemsPerPage: 20,
				totalItems: 0,
				isLoading: false,
				options_numRowsOnPage: [
					{ value: 20, text: '20' },
					{ value: 100, text: '100' },
					{ value: 200, text: '200' }
				],
				empty_text: '',
				empty_filtered_text: 'Ni zadetkov',
				inputFilter: {
					spOrderId: null
				},
				textFilterTimeout: null,
				errorText: ''
			},
			newSpOrderItem: {
				id: null,
				sp_order_id: null,
				catalog_number: null,
				title: null,
				status: null,
				estimated_delivery_date: null,
				note: null,
				info: null,
				stock: null,
				in_house: false
			},
			isSpOrderItemEditing: false,
			permissionCheck: PermissionCheck,
			selectedBrand : null,
			vehicle_options: [],
			isSpOrderEditing: false,
			spOrderOkButton: {
				title: 'Dodaj'
			},
			registrationNumberCopied: false,
			vinCopied: false,
			spOrderNumberCopied: false,
			editingRecord: {
				id: null,
				type: null,
				object_id: null,
				data_at_start: null,
				forced_edit: false
			},
			catalogNumber_options: [],
			orderNumber_options: [],
			spOrderCommentsTableProps: {
				fields: [
					{ key: 'created_by', label: 'Avtor', sortable: true, class: 'tdSpOrderCommentsCreatedBy' },
					{ key: 'content', label: 'Vsebina', sortable: true, class: '' },
					{ key: 'created_at', label: 'Ustvarjen dne', sortable: true, class: 'tdSpOrderCommentsCreatedAt' },
				],
				sortDesc: true,
				currentPage: 1,
				itemsPerPage: 10,
				totalItems: 0,
				isLoading: false,
				options_numRowsOnPage: [
					{ value: 10, text: '10' },
					{ value: 100, text: '100' },
					{ value: 200, text: '200' }
				],
				empty_text: '',
				empty_filtered_text: 'Ni zadetkov',
				inputFilter: {
					spOrderId: null
				},
				textFilterTimeout: null,
				errorText: ''
			},
			spOrderJobsTableProps: {
				fields: [
					{ key: 'job_id', label: 'Id', sortable: true, class: 'tdSpOrderJobsId' },
					{ key: 'job_code', label: 'Koda', sortable: true, class: 'tdSpOrderJobsCode' },
					{ key: 'description', label: 'Opis', sortable: true, class: '' },
				],
				sortDesc: true,
				currentPage: 1,
				itemsPerPage: 10,
				totalItems: 0,
				isLoading: false,
				options_numRowsOnPage: [
					{ value: 10, text: '10' },
					{ value: 100, text: '100' },
					{ value: 200, text: '200' }
				],
				empty_text: '',
				empty_filtered_text: 'Ni zadetkov',
				inputFilter: {
					spOrderId: null
				},
				textFilterTimeout: null,
				errorText: ''
			},
			selectedTabIndex: 0,
			selectedOrderer: null,
			replacementVehicles: [],
			selectedReplacementVehicle: null,
			currentReplacementVehicleReservation: {
				id: null,
				replacementVehicleId: null,
				spOrderId: null,
				startsOn: null,
				endsOn: null
			},
			tmpOrderAttachments: null,
			spOrderAttachmentsToUpload: [],
			spOrderAttachmentsToUploadTable_props: {
				fields: [
					{ key: 'file', label: '', sortable: false },
					{ key: 'progress', label: '', sortable: false, class: 'orderAttachmentsTdProgress'  }
				],
			},
			spOrderAttachmentsToSave: [],
			spOrderAttachmentsTableProps: {
				fields: [
					{ key: 'preview', label: '', sortable: true, class: 'tdSpOrderAttachmentsPreview align-middle' },
					{ key: 'orginal_filename', label: '', sortable: true, class: 'align-middle' },
					{ key: 'actions', label: '', sortable: true, class: 'tdSpOrderAttachmentsActions align-middle' },
				],
				sortDesc: true,
				currentPage: 1,
				itemsPerPage: 10,
				totalItems: 0,
				isLoading: false,
				options_numRowsOnPage: [
					{ value: 10, text: '10' },
					{ value: 100, text: '100' },
					{ value: 200, text: '200' }
				],
				empty_text: '',
				empty_filtered_text: 'Ni zadetkov',
				inputFilter: {
					spOrderId: null
				},
				textFilterTimeout: null,
				errorText: ''
			},
			selectedServiceAdvisor: null,
			movingSpOrderItemsInProgress: false,
			moveSpOrderItemsToSpOrder: null,
			spOrders_options: [],
		}
	},
	watch: {
	},
	computed: {
		profile() {
			return this.$store.getters.getProfile
		},
		modalSize () {
			return 'xl';
		},
		allVehicleBrands: function() {
			if (this.$store.getters.getAllVehicleBrands) {
				return this.$store.getters.getAllVehicleBrands;
			} else {
				this.$store.dispatch(VEHICLE_BRANDS_LIST_ALL)
					.then((responseData) => {
						console.log(responseData);
						return responseData.vehicleBrands;
					})
					.catch(error => {
						console.error(error);
					});
			}
		},
		editingDisabled () {
			if (this.mode === this.mode_DETAILS3) {
				return true;
			}
			return false;
		},
		spOrderItemsEditingDisabled () {
			if (this.mode === this.mode_DETAILS3 || this.permissionCheck.is('sprejemnik')) {
				return true;
			}
			return false;
		},
		showSpOrderItemsTableNav () {
			if (this.spOrderItemsTableProps.totalItems > this.spOrderItemsTableProps.itemsPerPage) {
				return true;
			}
			return false;
		},
		showSpOrderCommentsTableNav () {
			if (this.spOrderCommentsTableProps.totalItems > this.spOrderCommentsTableProps.itemsPerPage) {
				return true;
			}
			return false;
		},
		showSpOrderJobsTableNav () {
			if (this.spOrderJobsTableProps.totalItems > this.spOrderJobsTableProps.itemsPerPage) {
				return true;
			}
			return false;
		},
		modalOkButtonData () {
			if (this.mode === this.mode_CREATE1) {
				return {
					label: 'Dodaj',
					title: 'Dodaj naročilnico'
				}
			} else if (this.mode === this.mode_EDIT2) {
				if (this.isSpOrderItemEditing) {
					return {
						label: 'Končaj urejanje',
						title: 'Najprej shranite/prekličite spremembe na postavkah'
					}
				}
				return {
					label: 'Končaj urejanje',
					title: 'Končaj urejanje in shrani naročilnico'
				}
			} else if (this.mode === this.mode_DETAILS3) {
				return {
					label: 'Uredi',
					title: 'Uredi'
				}
			}
			return {
				label: '',
				title: ''
			};
		},
		spOrderItemsStatusOptions () {
			return this.settings.spOrderItemsStatusOptions.filter(function(obj) {
				return obj.value !== '#';
			});
		},
		spOrderItemsTableFields: function () {
			let fields = [];
			fields.push({ key: 'catalog_number', label: 'Kataloška št. ND', sortable: true, class: 'tdSpOrderItemCatalogNumber' });
			fields.push({ key: 'title', label: 'Naziv ND', sortable: true, class: 'tdSpOrderItemTitle' });
			fields.push({ key: 'note', label: 'Opomba', sortable: true, class: 'tdSpOrderItemNote' });
			fields.push({ key: 'stock', label: 'Količina', sortable: true, class: 'tdSpOrderItemNote' });
			fields.push({ key: 'status', label: 'Status', sortable: true, class: this.mode === this.mode_EDIT2 ? 'tdSpOrderItemStatus' : 'tdSpOrderItemStatusDetails' });
			fields.push({ key: 'estimated_delivery_date', label: 'Predvidena dobava', sortable: true, class: 'tdSpOrderItemEstimatedDeliveryDate' });
			fields.push({ key: 'created_at', label: 'Datum naročila', sortable: true, class: 'tdSpOrderItemCreatedAt' });
			fields.push({ key: 'in_house', label: 'ND v hiši', sortable: true, class: 'tdSpOrderItemInHouse' });
			fields.push({ key: 'info', label: 'Info', sortable: true, class: 'tdSpOrderItemInfo' });
			if (this.mode === this.mode_EDIT2) {
				fields.push({ key: 'actions', label: '', sortable: false, class: 'tdSpOrderItemActions' });
			}
			if (this.movingSpOrderItemsInProgress) fields.push({ key: 'selection', label: 'Postavke za premik', sortable: false, tdClass: 'text-center tdSpOrderItemActions' });
			return fields;
		},
		spOrderItemsTableClass () {
			if (this.mode == this.mode_EDIT2) {
				return 'mb-1 spOrderItemsTable';
			}
			return 'mb-1';
		},
		uploadPlaceholder () {
			return PH_TEXT;
		},
		showSpOrderAttachmentsTableNav () {
			if (this.spOrderAttachmentsTableProps.totalItems > this.spOrderAttachmentsTableProps.itemsPerPage) {
				return true;
			}
			return false;
		},
		today () {
			let today = new Date();
			today.setUTCHours(0,0,0,0);
			return today;
		}
	},
	created () {
		this.$store.dispatch(REPLACEMENT_VEHICLES_ALL)
			.then((responseData) => {
				this.replacementVehicles = responseData.replacementVehicles;
			})
			.catch(error => {
				console.error(error);
		});
	}
}
</script>

<style scoped>
#spOrderCustomActions {
  position: absolute;
  top: 1.4rem;
  right: 1.4rem;
  z-index: 1;
}
.ma_pos {
	text-align: end;
}
.addingSpOrderItemsRow {
	background-color: #B9BABC;
}
.inTableInput {
	margin-bottom: 0px !important;
}
.copyButton {
	margin-top: 2rem;
	margin-left: 0rem;
}
.copyButtonClicked {
	margin-top: 0.7rem;
	margin-left: 0rem;
}
</style>
<style>
.tdSpOrderItemCatalogNumber {
	width: 9rem;
	min-width: 9rem;
}
.tdSpOrderItemTitle {
	width: 11rem;
}
.tdSpOrderItemStatus {
	width: 10rem;
	min-width: 10rem;
	max-width: 10rem;
}
.tdSpOrderItemStatusDetails {
	width: 7rem;
	min-width: 7rem;
	max-width: 7rem;
}
.tdSpOrderItemEstimatedDeliveryDate {
	width: 7rem;
	min-width: 7rem;
	max-width: 7rem;
}
.tdSpOrderItemCreatedAt {
	width: 7rem;
	min-width: 7rem;
	max-width: 7rem;
}
.tdSpOrderItemNote {
	width: 2rem;
}
.tdSpOrderItemInfo {
	width: 5rem;
	min-width: 5rem;
}
.tdSpOrderItemInHouse {
	width: 7rem;
	min-width: 7rem;
	max-width: 7rem;
}
.tdSpOrderItemActions {
	width: 6rem;
	min-width: 6rem;
}
div.modal .modal-dialog.modal-1600 {
  max-width: 1600px !important;
}
.spOrderItemsTable {
	min-height: 350px;
}
.tdSpOrderCommentsCreatedBy {
	width: 12rem;
	min-width: 12rem;
}
.tdSpOrderCommentsCreatedAt {
	width: 12rem;
	min-width: 12rem;
}
.tdSpOrderJobsId {
	width: 4rem;
	min-width: 4rem;
}
.tdSpOrderJobsCode {
	width: 4rem;
	min-width: 4rem;
}
.tdSpOrderAttachmentsActions {
	width: 7rem;
	min-width: 7rem;
}
.tdSpOrderAttachmentsPreview {
	width: 8rem;
	min-width: 8rem;
}
</style>